export const Entities = [
  {
    Hostname: '3880',
    Name: '',
    ID: '',
  },
  {
    Hostname: '0001abcd',
    Name: '',
    ID: '',
  },
  {
    Hostname: '253-am',
    Name: '253 Farmacy - Amherst',
    ID: '4db13e5d-f640-41d8-a962-6d0229077b70',
  },
  {
    Hostname: '253-tf',
    Name: '253 Farmacy - Turners Falls',
    ID: '17d828a6-279b-47e5-8c3f-81296cca4fe3',
  },
  {
    Hostname: '420centralcm',
    Name: '420 Central - Newport Costa Mesa',
    ID: 'a75ef513-2a58-4df4-8fc5-d58da074608f',
  },
  {
    Hostname: '420centralsa',
    Name: '420 Central - Santa Ana',
    ID: 'e56820e0-b48f-44c3-bea9-713b7cb901fa',
  },
  {
    Hostname: '7engines',
    Name: '7 Engines - Buchanan',
    ID: 'daa9d22e-ca8f-453d-9609-b304fff425a8',
  },
  {
    Hostname: '818ps',
    Name: '818 Brands Dispensary Palm Springs',
    ID: 'd8dfae54-a43e-4172-9c5f-e19c34712500',
  },
  {
    Hostname: '818sc',
    Name: 'The Weed Powered by 818 Brands',
    ID: '90d8245b-b700-4d17-bdc9-d8e108d16b4e',
  },
  {
    Hostname: 'a21',
    Name: 'A21',
    ID: '2ca56d32-18ec-4fa1-b4e5-9b0cfec5d666',
  },
  {
    Hostname: 'abatinsacramento',
    Name: 'Abatin - Sac',
    ID: '0b22a66e-e1b9-4751-85b0-f12f988cbcab',
  },
  {
    Hostname: 'agoldenstate',
    Name: 'A Golden State',
    ID: '90a4a153-87d2-4fb2-94b5-d20cdea9c8ee',
  },
  {
    Hostname: 'alternatives',
    Name: 'Alternatives - Santa Rosa Hampton',
    ID: '82adce5f-41a2-459f-a0b1-025f2115d324',
  },
  {
    Hostname: 'alternativeseast',
    Name: 'Alternatives - Santa Rosa East',
    ID: '90e68303-cf60-438e-b1d8-1ee010372ea3',
  },
  {
    Hostname: 'amazingbudz',
    Name: 'Amazing Budz - Adrian',
    ID: 'dcbc53a7-cbc4-4bd7-96e7-59d802980767',
  },
  {
    Hostname: 'apothecariumgreen',
    Name: 'Apothecarium Green',
    ID: '5324aeaa-d0d4-4a11-8aa0-b36a9bbde5d2',
  },
  {
    Hostname: 'apothodartmouth',
    Name: 'Apotho Therapeutics- Dartmouth',
    ID: '6d7be709-e1f2-42f4-be54-5a672176817f',
  },
  {
    Hostname: 'atherapeutic',
    Name: 'A Therapeutic Alternative - Sacramento',
    ID: 'e0437b3b-98f7-47ff-8a04-f4a6d28ac814',
  },
  {
    Hostname: 'aurumbotanics-pemberton',
    Name: 'Aurum Botanics - Pemberton',
    ID: '1955221e-1f8b-405a-85e5-b30865176a2b',
  },
  {
    Hostname: 'avacannabisnyc',
    Name: 'AVA Cannabis',
    ID: '8ea13cfa-9aa6-4aab-896c-7fd293389d6f',
  },
  {
    Hostname: 'azcs',
    Name: 'Arizona Cannabis Society - El Mirage',
    ID: '3a886c11-ab95-4330-85a6-b5277bef70db',
  },
  {
    Hostname: 'backcountrycannabis',
    Name: 'Back Country Cannabis',
    ID: '4104f610-c5de-4fa6-959e-069a2902b631',
  },
  {
    Hostname: 'backpack-1',
    Name: 'Backpack - 1 - Mastic',
    ID: '1fe0621a-e979-4398-affb-37ea51593e65',
  },
  {
    Hostname: 'backpack-2',
    Name: 'Backpack - 2 - Piermont',
    ID: 'fba0b6e6-ced1-4ac2-bd01-f76be713abfc',
  },
  {
    Hostname: 'backpackboyzsb',
    Name: 'Backpack Boyz - San Bernardino',
    ID: 'abe9d1ab-a018-45b5-bf66-c12bec9c25c1',
  },
  {
    Hostname: 'barbarycoast',
    Name: 'Barbary Coast - SF Mission',
    ID: 'ae6b5e08-38e9-40cc-ad8e-d6267145166f',
  },
  {
    Hostname: 'bcaf-nj',
    Name: 'B Caf',
    ID: '6a9c08b4-6553-4815-939a-96306c5f2f5c',
  },
  {
    Hostname: 'beachfire1',
    Name: 'Beach Fire - Williamsburg',
    ID: 'f6c8c778-03e5-4da2-bd29-e0ffff0ae014',
  },
  {
    Hostname: 'benzeenlabrea',
    Name: 'Benzeen La Brea',
    ID: '44e9a3c6-0d64-4c64-85ce-d07cc39465a0',
  },
  {
    Hostname: 'best',
    Name: 'Jamestown - Mesa',
    ID: 'e01466b5-7e6b-4ee1-827b-6c04c1e49d71',
  },
  {
    Hostname: 'bestbuds',
    Name: 'Best Buds Dispensary - Woodbury',
    ID: '26ae10a0-0ffc-48df-9016-ce97428a8af0',
  },
  {
    Hostname: 'bf1',
    Name: 'Caliva - Bellflower',
    ID: 'ef179fe6-6cf5-45c2-8427-2d86ce612cf5',
  },
  {
    Hostname: 'billo',
    Name: 'Billo',
    ID: '363a1d65-762a-4ced-9801-f24324f94147',
  },
  {
    Hostname: 'blackstone',
    Name: 'Embarc - Fresno Blackstone',
    ID: '9a9038a2-0afe-46b8-b0ac-e39bee06b689',
  },
  {
    Hostname: 'blazedutopiale',
    Name: 'Blazed Utopia - Lake Elsinore',
    ID: '1409d9dc-abc3-42d7-91ae-1559d57d9f30',
  },
  {
    Hostname: 'blazedutopiasj',
    Name: 'Blazed Utopia - San Jacinto',
    ID: '4225cb1f-5f2c-49e8-bc3c-8889d0589825',
  },
  {
    Hostname: 'bleeziescos',
    Name: 'Bleezies - Colorado Springs',
    ID: '1380d792-f139-4323-b873-0405567c902e',
  },
  {
    Hostname: 'blissandlex-ues',
    Name: 'Bliss+Lex - UES',
    ID: '57582e0c-8ec9-45a8-9d94-c143ac362ad1',
  },
  {
    Hostname: 'blissfulmoments',
    Name: 'Blissful Moments',
    ID: '71ae9add-b8ea-4037-b101-561fef3e0b8f',
  },
  {
    Hostname: 'bloomroompacifica',
    Name: 'Bloom Room - Pacifica',
    ID: '029d6fd8-e27f-4e87-9af0-f4559ae86ca2',
  },
  {
    Hostname: 'bluegreen',
    Name: 'Bluegreen - Belden/Tupelo',
    ID: 'e1239a25-5661-4ede-aa34-946e573c64f9',
  },
  {
    Hostname: 'blulight-gc',
    Name: 'Blulight Cannabis- Gloucester City',
    ID: 'd85ddac1-90d4-4878-8fc9-9fef30be681c',
  },
  {
    Hostname: 'blulight-wbh',
    Name: 'BluLight Cannabis - Woodbury Heights',
    ID: '7686db66-9bf9-4e93-8a42-abd3046b8b4a',
  },
  {
    Hostname: 'bmbr',
    Name: 'BesaMe - Kansas City Barry',
    ID: '246e07a6-7f0a-4f14-85f9-44b563ec08f7',
  },
  {
    Hostname: 'bmdex',
    Name: 'Verts - Dexter',
    ID: '8f244f4d-fb8e-491c-b156-6b42c04d61a0',
  },
  {
    Hostname: 'bmgal',
    Name: 'Verts - Gallatin',
    ID: '666003a3-d26c-45e1-9d41-9e0766003aa8',
  },
  {
    Hostname: 'bmjop',
    Name: 'Verts - Joplin',
    ID: '8a01b8e1-04f9-4392-a7d9-64b371a7c1c7',
  },
  {
    Hostname: 'bmlib',
    Name: 'BesaMe - Liberty',
    ID: 'e0b2dc35-baaa-42e6-ae9f-5908862a78fb',
  },
  {
    Hostname: 'bmnkc',
    Name: 'BesaMe - North Kansas City',
    ID: '69d62f1e-1172-4383-9c7f-957feda23d15',
  },
  {
    Hostname: 'bmpac',
    Name: 'Verts - Pacific',
    ID: '08016637-79d3-43d3-94ba-847282009058',
  },
  {
    Hostname: 'bmsv',
    Name: 'BesaMe - Smithville',
    ID: '0661b6a1-94cf-49a7-a3f2-c2ab4aaf34a1',
  },
  {
    Hostname: 'bmwar',
    Name: 'BesaMe - Warrensburg',
    ID: 'c8e5d662-8c84-43ef-8116-a7bfdd4cee07',
  },
  {
    Hostname: 'botanica',
    Name: 'Botanica - Tucson',
    ID: 'e15daaae-1274-426f-ac66-017304fa1ad8',
  },
  {
    Hostname: 'bpg',
    Name: 'Berkeley Patients Group',
    ID: '8e976c21-6982-4ab6-b131-0b5bb846fe48',
  },
  {
    Hostname: 'brentwoodgreens',
    Name: 'Brentwood Greens',
    ID: 'fbd5f48d-7f0a-4d37-b064-d50847ffb20c',
  },
  {
    Hostname: 'broccoli',
    Name: 'Broccoli',
    ID: '2a8f7183-5ee7-4530-aeb9-d2b0988aeafd',
  },
  {
    Hostname: 'cacollective',
    Name: 'CA Collective - San Jose',
    ID: 'f57cf289-c0b4-4794-a962-7b4a5973a2f4',
  },
  {
    Hostname: 'californiaholistics',
    Name: 'California Holistics',
    ID: '5895bda8-1c78-4ccb-874b-4451fcbe9333',
  },
  {
    Hostname: 'calmaweho',
    Name: 'Calma - West Hollywood',
    ID: 'cb415714-59b9-495c-8d8e-9d2cb8221cd7',
  },
  {
    Hostname: 'camdenapothecary',
    Name: 'Camden Apothecary - Camden',
    ID: 'eb6693b0-1c51-43e7-99cc-3cdfea39cca1',
  },
  {
    Hostname: 'cana-beverly',
    Name: 'Caña - Beverly',
    ID: '3647660f-6b1e-4b44-866e-29fb0ca84531',
  },
  {
    Hostname: 'cana-sylmar',
    Name: 'Caña - Sylmar',
    ID: '3c72d96b-3d9e-4e60-aa42-d45870b19ee9',
  },
  {
    Hostname: 'cannabiscentral-halfmoon',
    Name: 'Cannabis Central - Halfmoon, NY',
    ID: '6eafdb9c-acda-463e-84aa-30a9f95d364f',
  },
  {
    Hostname: 'cannabisclubhouse-nj',
    Name: 'Cannabis Clubhouse',
    ID: 'c7a777ee-c46f-4367-9219-6b208e50549a',
  },
  {
    Hostname: 'cannablissnj',
    Name: 'A-Z Supply Inc.',
    ID: 'e8b4b266-e893-48f5-b4f5-f43a7cfe34b0',
  },
  {
    Hostname: 'cannablue',
    Name: 'Cannablue - South Lake Tahoe',
    ID: '3abf6a55-825f-4c37-ac2e-daee4b1977f8',
  },
  {
    Hostname: 'cannabosslady',
    Name: 'Elevated by TheCannabossLady',
    ID: 'cdd9ce81-6261-42f5-a735-aa89c9c2aee6',
  },
  {
    Hostname: 'cannaboytreehouse',
    Name: 'CannaBoy Treehouse - South Orange',
    ID: '6c454482-9466-4479-b8d5-ebd75dd658c9',
  },
  {
    Hostname: 'cannacruzaptos',
    Name: 'CannaCruz - Aptos',
    ID: 'dc52e702-ee47-42bf-92cb-bb5f22b22d33',
  },
  {
    Hostname: 'cannacruzsalinas',
    Name: 'CannaCruz - Salinas',
    ID: '5db203a8-ff90-4412-b4f4-5ae6ae3cd6e2',
  },
  {
    Hostname: 'cannacruzsantacruz',
    Name: 'CannaCruz - Santa Cruz',
    ID: 'dc48206a-3bfc-461b-a48f-f3d390c9f92c',
  },
  {
    Hostname: 'cannacruzwatsonville',
    Name: 'CannaCruz - Watsonville',
    ID: '7ee32a81-0790-412e-aa59-a0cfbde66d30',
  },
  {
    Hostname: 'cannaculture',
    Name: 'Canna Culture - San Jose',
    ID: 'f4c086a6-75c0-40f3-ab91-8c0cabc8c7e9',
  },
  {
    Hostname: 'cannajunction',
    Name: 'Canna Junction - Susanville',
    ID: 'f7ceb2e4-2080-44f4-a879-65425416cd01',
  },
  {
    Hostname: 'cannaklub',
    Name: 'Canna Klub - Luzerne',
    ID: '2f8439b4-b2a9-4f5b-a742-ff2bdd9e2795',
  },
  {
    Hostname: 'cannaklub2',
    Name: 'Canna Klub - Wolverine',
    ID: '346825f4-d1c3-4a9b-b118-c114cae9382f',
  },
  {
    Hostname: 'cannaklub3',
    Name: 'Canna Klub - Rose City',
    ID: '0de7108f-2d8d-4928-bc40-6ee149e67392',
  },
  {
    Hostname: 'cannavine',
    Name: 'Cannavine - Ukiah',
    ID: '034b5316-6a5e-4f0e-998c-ae50efeb71e8',
  },
  {
    Hostname: 'cannavinesf',
    Name: 'Cannavine - SF',
    ID: '26ae0086-0dd0-460a-b198-f6c51d9eaa11',
  },
  {
    Hostname: 'cannavinesr',
    Name: 'Cannavine - SR',
    ID: 'db483259-6286-466a-bb95-30d58d6a5358',
  },
  {
    Hostname: 'canopycrossroad',
    Name: 'Canopy Crossroad - Red Bank',
    ID: '4a4ca753-a831-404b-b353-2bda7b94b007',
  },
  {
    Hostname: 'carryon-williamstown',
    Name: 'Carry On - Williamstown',
    ID: '898e34bb-8b4b-4515-b8cc-9024cc8c8f80',
  },
  {
    Hostname: 'catalyst10th',
    Name: 'Catalyst - 10th Street',
    ID: 'd57ca3a5-ced1-4233-9ee3-7b75cc9e77c0',
  },
  {
    Hostname: 'catalyst405',
    Name: 'Catalyst - Cherry 405',
    ID: '4fad603b-f747-403f-986d-b63fc2c693ff',
  },
  {
    Hostname: 'catalystantioch',
    Name: 'Catalyst - Antioch',
    ID: 'ec386622-b83b-45cd-a3f8-ab05803f6c15',
  },
  {
    Hostname: 'catalystbellflower',
    Name: 'Catalyst - Bellflower',
    ID: '48ab2aa6-47d4-4dca-a4cd-dec8102f97e8',
  },
  {
    Hostname: 'catalystbelmont',
    Name: 'Catalyst - Belmont Shore',
    ID: 'd0d93bd5-f679-4a52-add1-53b35a1fb8da',
  },
  {
    Hostname: 'catalystcostamesa',
    Name: 'Catalyst - Costa Mesa',
    ID: '28f6623a-e891-48c3-b975-1f0d62faa126',
  },
  {
    Hostname: 'catalystdalycity',
    Name: 'Catalyst - Daly City',
    ID: 'f477ee5f-b120-4f42-af58-0bd5f90210b1',
  },
  {
    Hostname: 'catalystelmonte',
    Name: 'Catalyst - El Monte',
    ID: 'c718aaf3-3785-42cd-bcef-ba64a2e4f957',
  },
  {
    Hostname: 'catalystfigueroa',
    Name: 'Catalyst - Figueroa',
    ID: '85af63a5-e7c4-4f0f-aa2f-91b310233d9f',
  },
  {
    Hostname: 'catalystflorence',
    Name: 'Catalyst - Florence',
    ID: 'f9b96985-cd48-4b25-8d68-8670610cfdea',
  },
  {
    Hostname: 'catalystgroverbeach',
    Name: 'Catalyst - Grover Beach',
    ID: '583eb7de-09b7-48d1-abbb-a342bc77a3a3',
  },
  {
    Hostname: 'catalysthawthorne',
    Name: 'Catalyst - Hawthorne',
    ID: '0aaf280a-4c8f-4c56-a35d-5ddf9cd6b11e',
  },
  {
    Hostname: 'catalysthemet',
    Name: 'Catalyst - Hemet',
    ID: '737f2a9b-d390-4a1f-b54b-b2469d59c153',
  },
  {
    Hostname: 'catalystlancaster',
    Name: 'Catalyst - Lancaster',
    ID: '71306beb-ac4c-4f1c-9986-dd645e1ec7ef',
  },
  {
    Hostname: 'catalystlynwood',
    Name: 'Catalyst - Lynwood',
    ID: 'fbd2c2a5-4cfd-4e21-a7fb-a012a489d848',
  },
  {
    Hostname: 'catalystmarina',
    Name: 'Catalyst - Marina',
    ID: '166a4c92-cf7e-4c2c-9f58-b43618e26d52',
  },
  {
    Hostname: 'catalystmidcity',
    Name: 'Catalyst - Mid-Wilshire',
    ID: '78562611-4f3a-4826-ae5e-d244c3317e2e',
  },
  {
    Hostname: 'catalystmorenovalley',
    Name: 'Catalyst - Moreno Valley',
    ID: '78fce4ba-0546-461d-9dbe-f18bdb849e8d',
  },
  {
    Hostname: 'catalystnormandie',
    Name: 'Catalyst - Normandie',
    ID: '61f0f406-a1c4-4d51-99ff-015c48b62a12',
  },
  {
    Hostname: 'catalystoxnard',
    Name: 'Catalyst - Oxnard',
    ID: '207f702c-44d1-4811-a3ae-16247d2d2f23',
  },
  {
    Hostname: 'catalystpalmdesert',
    Name: 'Catalyst - Palm Desert',
    ID: '184633a7-6c59-4dca-937b-a8d89fcf1f80',
  },
  {
    Hostname: 'catalystpatterson',
    Name: 'Catalyst - Patterson',
    ID: '7cde6e25-2f25-4c8d-aa23-737596269bfb',
  },
  {
    Hostname: 'catalystpine',
    Name: 'Catalyst - DTLB',
    ID: 'fc985368-57ec-4b57-8069-b6007eb66378',
  },
  {
    Hostname: 'catalystpomona',
    Name: 'Catalyst - Pomona',
    ID: 'b2a465ad-a3b7-4684-abd7-3170a08ab16e',
  },
  {
    Hostname: 'catalystsandiego',
    Name: 'Catalyst - San Diego',
    ID: '5220c5be-c43b-48b3-8bee-a957d8766191',
  },
  {
    Hostname: 'catalystsantaana',
    Name: 'Catalyst - Santa Ana',
    ID: '48ef0654-d5a2-4cbe-a5f6-e1445da65a7b',
  },
  {
    Hostname: 'catalystsbinland',
    Name: 'Catalyst - San Bernardino',
    ID: 'd1d60a75-e092-435a-a9fd-01559976a6f0',
  },
  {
    Hostname: 'catalystsilverlake',
    Name: 'Catalyst - Silver Lake',
    ID: '00241986-8d2d-4dcf-bdc3-674314fe9023',
  },
  {
    Hostname: 'catalyststanton',
    Name: 'Catalyst - Stanton',
    ID: '3fdd0a41-91de-41a4-a878-2e2610fbdfe1',
  },
  {
    Hostname: 'catalystvannuys',
    Name: 'Catalyst - Van Nuys',
    ID: '0268d39e-df2a-4175-b4cc-9e8c5431f512',
  },
  {
    Hostname: 'catalystwatsonville',
    Name: 'Catalyst - Watsonville',
    ID: '33d58d19-92bd-4d53-83da-8827fcde3b66',
  },
  {
    Hostname: 'cbcbberkeley',
    Name: 'CBCB - Berkeley',
    ID: 'f38d73a6-948a-4698-b188-8c4b91d39520',
  },
  {
    Hostname: 'cherrykolasr',
    Name: 'Cherry Kola - Santa Rosa',
    ID: '25ab66c9-ac84-4bba-8281-136fc24095a2',
  },
  {
    Hostname: 'chucks',
    Name: "Chuck's Wellness - Placerville",
    ID: '5b0617b8-3f7c-48e0-8fe4-d441594a62c9',
  },
  {
    Hostname: 'ckmodesto',
    Name: 'Cali Kosher - Modesto',
    ID: '7ab26127-e93c-4e55-831e-5c05952355b4',
  },
  {
    Hostname: 'ckoakdale',
    Name: 'Cali Kosher - Oakdale',
    ID: '0a2f5f05-c65a-42fd-9c64-715756f4bfc2',
  },
  {
    Hostname: 'ckpatterson',
    Name: 'Cali Kosher - Patterson',
    ID: '7ec05e37-1663-4dd5-aa14-a38d08949086',
  },
  {
    Hostname: 'cloudnine-nj',
    Name: 'Cloud Nine',
    ID: 'c1b813cf-f67a-44ae-accd-881a967f6b99',
  },
  {
    Hostname: 'club78',
    Name: 'Platinum Club/ Club 78',
    ID: '34d70154-13ac-4362-81e0-9356c6e81fca',
  },
  {
    Hostname: 'cmcc',
    Name: 'California Michigan Cannabis Co. - Montgomery',
    ID: 'de2a3590-3530-4516-9b78-a2e8df268097',
  },
  {
    Hostname: 'co1',
    Name: 'Coastal - Concord',
    ID: '841092be-d4cd-4c93-9e5e-f3cbc4f48bf3',
  },
  {
    Hostname: 'coachellagreenery',
    Name: 'Coachella Greenery',
    ID: '3c9be0ea-fd6f-4248-bbf6-5497bafad24f',
  },
  {
    Hostname: 'completereleaf',
    Name: 'Complete Releaf',
    ID: 'fc738bc1-4da0-4fd7-9ab4-122e23536942',
  },
  {
    Hostname: 'connectedevents',
    Name: 'Connected - Events',
    ID: 'ae7c44bf-4138-40e9-ad8a-350bd6f78442',
  },
  {
    Hostname: 'connectedsac',
    Name: 'Connected - Sac',
    ID: '8bebe6f2-69c6-4e47-a9eb-83140d87ec5d',
  },
  {
    Hostname: 'connectedsf',
    Name: 'Connected - SF',
    ID: 'fc47afd1-2bca-4a38-8e14-89898f8b4309',
  },
  {
    Hostname: 'connectedstk',
    Name: 'Connected - Stockton',
    ID: '463660fa-496c-45ef-830a-b7d7562ae66b',
  },
  {
    Hostname: 'conservatory',
    Name: 'Conservatory Cannabis - Egg Harbor Township',
    ID: '6be29bb7-0b20-48b5-9e9c-dfd364005595',
  },
  {
    Hostname: 'cookies-blm',
    Name: 'Cookies - Bloomington',
    ID: '9dfdef78-33f7-4ccc-bddf-bac910370fe1',
  },
  {
    Hostname: 'cookies-pb',
    Name: 'Cookies - Pontoon Beach',
    ID: 'c671547a-e2f0-4a20-9654-e0d80e80e300',
  },
  {
    Hostname: 'cookies-ph',
    Name: 'Cookies - Peoria Heights',
    ID: 'a506dcdc-de4a-44c4-8509-fe743f968be8',
  },
  {
    Hostname: 'cookiesfv',
    Name: 'Cookies - Mission Valley',
    ID: 'a9855c0e-de19-49c2-86bc-af3cf3651403',
  },
  {
    Hostname: 'cookiessa',
    Name: 'Cookies - Santa Ana',
    ID: 'eb3ff62f-6822-4803-ae8d-d2c977191966',
  },
  {
    Hostname: 'cornerstone',
    Name: 'Cornerstone Research Collective',
    ID: 'eb5025ef-c1dd-4cb8-8166-61b3c71d5873',
  },
  {
    Hostname: 'coronaculture',
    Name: 'Corona Culture',
    ID: '9a4dfe16-7a3f-491d-83eb-5372dbbbccd2',
  },
  {
    Hostname: 'cr1',
    Name: 'Kings Crew - Corona',
    ID: 'e03ddf3c-c752-4719-8f8e-f2c6d2663f06',
  },
  {
    Hostname: 'crush',
    Name: 'Crush',
    ID: '35e704c2-1e0e-49f7-a893-7015fe7e2986',
  },
  {
    Hostname: 'culturecannabisclub',
    Name: 'Culture - Long Beach',
    ID: '5a14716d-fb95-48a0-9f41-2fa314980c4a',
  },
  {
    Hostname: 'culturecannabisclubfresnobullard',
    Name: 'Former Culture Bullard',
    ID: '500baa4c-d3b5-4c0b-9c02-363cae2e48dc',
  },
  {
    Hostname: 'culturecannabisfresnomaple',
    Name: 'Former Culture Maple',
    ID: '7e44dcd8-64f0-4289-971b-253d25bc136e',
  },
  {
    Hostname: 'culturefresnobullard',
    Name: 'Culture Fresno - Bullard',
    ID: 'd2c33ca8-7d89-4da0-83e6-0827615a6ac1',
  },
  {
    Hostname: 'culturefresnomaple',
    Name: 'Culture Fresno - Maple',
    ID: '7b089b10-e23c-4c45-9ef5-8e3574882074',
  },
  {
    Hostname: 'culturejurupavalley',
    Name: 'Culture Jurupa',
    ID: 'cda8c481-55d6-466b-a74d-daf526c888bc',
  },
  {
    Hostname: 'currentcannabis',
    Name: 'Current Cannabis',
    ID: 'ef8d8b1c-bb22-48a0-9153-cd72a41be285',
  },
  {
    Hostname: 'customersandbox1',
    Name: '',
    ID: '',
  },
  {
    Hostname: 'dankco',
    Name: 'Dank Colorado',
    ID: '636466e3-9cc6-4cb9-ab51-37b42e8652d3',
  },
  {
    Hostname: 'daviscannabis',
    Name: 'Davis Cannabis',
    ID: 'fa0d3d26-0c65-4a4b-9f8d-315388de1104',
  },
  {
    Hostname: 'dccollective',
    Name: 'DC Collective - Canoga Park',
    ID: '6b3991d8-7b66-45e2-9b71-81a4a6f52dc2',
  },
  {
    Hostname: 'dd',
    Name: 'Daly Dope',
    ID: 'e7223b44-ad1d-4eea-be63-9155f7e79045',
  },
  {
    Hostname: 'deltadispensary',
    Name: 'Delta Dispensary - Antioch',
    ID: 'b0ba98bc-6e0a-4dce-b120-6cd2675fd5f2',
  },
  {
    Hostname: 'desertkush',
    Name: 'Desert Kush - Cathedral Canyon Dr.',
    ID: '0c73dce4-12fe-48fa-99dd-51497f57d6e3',
  },
  {
    Hostname: 'desertkush111',
    Name: 'Desert Kush - Hwy 111',
    ID: '262ae51d-cff3-4a1d-b6c6-84238e6b369c',
  },
  {
    Hostname: 'devine',
    Name: 'Devine',
    ID: '4cbc7816-e4ad-45e8-afa6-a7af0db405b9',
  },
  {
    Hostname: 'downtownflwr',
    Name: 'Downtown FLWR - Jersey City',
    ID: 'd445aedf-45db-4851-9190-bec80c459973',
  },
  {
    Hostname: 'drasedwardsburg',
    Name: "Dr. A's Re-Leaf Center - Edwardsburg",
    ID: 'bd7f2bf0-0da3-4e1b-9b1f-ead651c2d129',
  },
  {
    Hostname: 'drgreenrx',
    Name: 'Dr. Green Rx - Vista',
    ID: '616e3b3e-18b3-4e97-8e6e-38e9dec5e164',
  },
  {
    Hostname: 'dtla',
    Name: 'LAHC',
    ID: 'd1e97bfc-9de9-4549-a61e-07a5e523aaef',
  },
  {
    Hostname: 'e7cathedralcity',
    Name: 'Element 7 - Cathedral City',
    ID: '78ba7aaa-b6d2-46ea-9205-3dea6fbffb1c',
  },
  {
    Hostname: 'e7chulavista',
    Name: 'Element 7 - Chula Vista',
    ID: '7cbc06e6-fa0f-42b8-8878-e466911b58dc',
  },
  {
    Hostname: 'e7firebaugh',
    Name: 'Element 7 - Firebaugh',
    ID: '679c7d84-3fd9-4bdd-8753-94ac82f5e2a3',
  },
  {
    Hostname: 'e7laurelvillage',
    Name: 'Element 7 - Laurel Village',
    ID: '51001508-6774-42ac-a038-0595df6f9b75',
  },
  {
    Hostname: 'e7marina',
    Name: 'Element 7 - Marina',
    ID: '96732c91-7b2e-4f9d-bba9-ac1e13baa4ad',
  },
  {
    Hostname: 'e7mendota',
    Name: 'Element 7 - Mendota',
    ID: '3c0c1164-5d48-4afc-ad3e-dc3a2f8c91b3',
  },
  {
    Hostname: 'e7montclair',
    Name: 'Element 7 - Mont Clair',
    ID: 'ceb55ab5-9c17-4eb7-a170-bb0090bc9156',
  },
  {
    Hostname: 'e7porthueneme',
    Name: 'Element 7 - Port Hueneme',
    ID: '9c02a237-f398-4d3a-b5e3-809ae7fc0c35',
  },
  {
    Hostname: 'e7willits',
    Name: 'Element 7 - Willits',
    ID: '23c6b4bf-618c-4e10-9a39-663b54d02338',
  },
  {
    Hostname: 'earthandivy',
    Name: 'Earth & Ivy - New Brunswick',
    ID: '3ea9cf49-39dd-4ffd-ad33-0a446b9e14e3',
  },
  {
    Hostname: 'earthandivy-lh',
    Name: 'Earth & Ivy - Lakehurst',
    ID: 'ff14e1f1-a2a4-47bf-b39d-fd811c79d92d',
  },
  {
    Hostname: 'ecommercesandbox',
    Name: 'Ecommerce Sandbox',
    ID: '6e210d2c-42cd-4fc8-99b1-7f00414de499',
  },
  {
    Hostname: 'eg1',
    Name: 'Empire Gardens - Perris',
    ID: '86b6ab5a-2f37-4d08-b84b-e9620f09b245',
  },
  {
    Hostname: 'eg2',
    Name: 'Empire Gardens - Moreno Valley',
    ID: 'f4143cd8-c03c-4953-91d3-7be68bd22eb9',
  },
  {
    Hostname: 'eh',
    Name: "Earth's Healing - Tucson South",
    ID: 'e7d11756-d43c-4e5d-b4ea-ea70024cfafa',
  },
  {
    Hostname: 'elevateadk',
    Name: 'Elevate ADK',
    ID: '07235b43-1466-4e2c-938b-8e8fb924818d',
  },
  {
    Hostname: 'elevated-herb',
    Name: 'Elevated Herb - West Milford',
    ID: '200584ea-a177-4d6c-b8c0-422ab80386c6',
  },
  {
    Hostname: 'elevatelompoc',
    Name: 'Elevate - Lompoc',
    ID: '95f5f56c-2883-4f86-9a7e-e14c9cdd354e',
  },
  {
    Hostname: 'elevation2477',
    Name: 'Elevation 2477 - Nevada City',
    ID: 'fd56e54b-1c07-43f9-ad06-c5deacb674dc',
  },
  {
    Hostname: 'elysian',
    Name: 'Elysian',
    ID: '763ec58f-739f-41ba-b2da-7612a13c253c',
  },
  {
    Hostname: 'embarcalameda',
    Name: 'Embarc - Alameda',
    ID: '5239dcba-f460-4728-b61f-1064a651fdd1',
  },
  {
    Hostname: 'embarcchico',
    Name: 'Embarc - Chico',
    ID: 'b52c7387-2908-4fcd-b18c-6f085fb077c9',
  },
  {
    Hostname: 'embarcfairfield',
    Name: 'Embarc - Fairfield',
    ID: 'a21b1ab2-5e1e-40dd-8aaf-0eeef8797797',
  },
  {
    Hostname: 'embarcfontana',
    Name: 'Embarc - Fontana',
    ID: 'c8f12a2d-faed-47d1-aeb5-a38f10b55a56',
  },
  {
    Hostname: 'embarcfresnoshaw',
    Name: 'Embarc - Fresno Shaw',
    ID: '94f43994-c54d-4e05-93c1-0403c636ecac',
  },
  {
    Hostname: 'embarcindio',
    Name: 'Embarc - Indio',
    ID: '55f2be11-651f-4fa0-807c-adcb778ea795',
  },
  {
    Hostname: 'embarcmadera',
    Name: 'Embarc - Madera',
    ID: '45d7b2a1-a511-4a90-abbd-5381aed672ce',
  },
  {
    Hostname: 'embarcmartinez',
    Name: 'Embarc - Martinez',
    ID: 'b813d573-3653-4b0a-881f-4d438e31beaa',
  },
  {
    Hostname: 'embarcmeyers',
    Name: 'Embarc - Meyers',
    ID: 'e8487153-ac44-4441-9654-315ed8776740',
  },
  {
    Hostname: 'embarcredwood',
    Name: 'Embarc - Redwood City',
    ID: 'eff86677-9cc2-4978-bcb2-9c38dd860cf9',
  },
  {
    Hostname: 'embarcsacramento',
    Name: 'Embarc - Sac',
    ID: '70f2ad16-3b4f-47d7-8e74-3f06409d208c',
  },
  {
    Hostname: 'embarcsanbruno',
    Name: 'Embarc - San Bruno',
    ID: '9703d8ff-7c2f-44da-893f-a33a04a24f7a',
  },
  {
    Hostname: 'embarcsandbox',
    Name: 'Embarc sandbox',
    ID: '39839f63-9422-40a0-aa79-f493e9595855',
  },
  {
    Hostname: 'embarctahoe',
    Name: 'Embarc - Tahoe',
    ID: '573e40bd-e0fc-489c-a4e1-b757738056d3',
  },
  {
    Hostname: 'embarctracy',
    Name: 'Embarc - Tracy',
    ID: '62771d8d-4465-4e2c-8a5b-c0c01f0127ad',
  },
  {
    Hostname: 'embarcventura',
    Name: 'Embarc - Ventura',
    ID: 'b02e6d10-1223-4482-b72e-6326c9f30da2',
  },
  {
    Hostname: 'embarcwoodland',
    Name: 'Embarc - Woodland',
    ID: '7a9ef63a-3162-42ce-8201-a2a095755950',
  },
  {
    Hostname: 'empiretwinpalms',
    Name: 'Empire - Twin Palms',
    ID: '3efd0199-c40d-4408-bb01-8dcfa8e68f1e',
  },
  {
    Hostname: 'endo',
    Name: 'Endo - Adrian',
    ID: '4a56df3a-1dcd-48ab-ae61-ae0b85fd95e4',
  },
  {
    Hostname: 'endohl',
    Name: 'Endo - Houghton Lake',
    ID: 'd5df7ace-3a24-403e-a3ae-08729649b1dc',
  },
  {
    Hostname: 'envycannaco',
    Name: 'KAI Cannabis - Muskegon',
    ID: '2bc72490-2da4-4a55-bef9-5a5544510fbc',
  },
  {
    Hostname: 'erba',
    Name: 'ERBA Pico',
    ID: '6ddf98e7-add1-4f08-936c-c17b7e484bc0',
  },
  {
    Hostname: 'erbasawtelle',
    Name: 'Swamp Capital / Erba 2 - Sawtelle',
    ID: '4488356a-23a7-4921-9d45-efe9206b0d53',
  },
  {
    Hostname: 'erbavenice',
    Name: 'ERBA Venice',
    ID: '1f6ca6b3-9a25-4f6b-8b9b-b882f237c759',
  },
  {
    Hostname: 'eskar-arlington',
    Name: 'Eskar - Arlington',
    ID: 'c5f1577c-2eca-4c56-b7e7-c32e054a5ec4',
  },
  {
    Hostname: 'ether',
    Name: 'Ether Dispensary',
    ID: '3741106c-2ba7-4e0c-98f0-6f83b6887586',
  },
  {
    Hostname: 'ether-buffalo',
    Name: 'Ether NY - Buffalo',
    ID: 'f6a2c98d-c10a-4035-90fd-09ed6c31d281',
  },
  {
    Hostname: 'exhibitburton',
    Name: 'Exhibit - Burton',
    ID: '1a39873c-f020-4b92-a67d-1308b9690ad2',
  },
  {
    Hostname: 'exhibitph',
    Name: 'Exhibit - Port Huron',
    ID: 'ddcfd0bb-dbd5-4268-869f-176c12e6496d',
  },
  {
    Hostname: 'exoticsadrian',
    Name: 'Exotics Adrian',
    ID: 'f2743838-7eb5-4c6e-bdb8-ff107ff5f320',
  },
  {
    Hostname: 'farmacyberkeley',
    Name: 'Berk - Farmacy',
    ID: '19e80577-7050-4604-ad64-2bc42752ace2',
  },
  {
    Hostname: 'farmacysantaana',
    Name: 'SA - Farmacy',
    ID: 'ad6cbd2e-2757-47b6-902c-7095242926a1',
  },
  {
    Hostname: 'farmacysy',
    Name: 'SY - Farmacy',
    ID: '11c30a36-e71b-4291-97ab-3853751fef62',
  },
  {
    Hostname: 'farmfresh',
    Name: 'Farm Fresh - Lake Havasu City',
    ID: '6b1c6ee5-3cc4-4cd5-884e-b07e7c82dae8',
  },
  {
    Hostname: 'farmhouse',
    Name: 'Farm House Artisan Market',
    ID: '1dd1b042-be86-4fa3-a3fd-535f471c883e',
  },
  {
    Hostname: 'fireandoak',
    Name: 'Fire & Oak - Mt. Holly',
    ID: '447a0a2d-13ba-48e9-a232-e9962e2b5350',
  },
  {
    Hostname: 'firehouse365',
    Name: 'Firehouse365',
    ID: '655181e6-bf39-4af8-b549-08227e4c35f6',
  },
  {
    Hostname: 'fivebuds',
    Name: 'Five Buds - Roscommon',
    ID: 'e8c720b6-969b-40cb-a404-e28d74203b42',
  },
  {
    Hostname: 'flora',
    Name: 'Flora Cannabis - East Lansing',
    ID: '2cfa1db7-b19f-416a-b865-5a6137156e13',
  },
  {
    Hostname: 'floraca',
    Name: 'Flora',
    ID: 'a8fb24a1-6da6-4fff-abe7-d206d30d31f9',
  },
  {
    Hostname: 'floro-evesham',
    Name: 'Floro - Evesham',
    ID: '3780904c-10e5-4f87-abb5-23a4d35490fd',
  },
  {
    Hostname: 'flowersupply',
    Name: 'Flower Supply',
    ID: '926816a6-1995-4f11-9887-3a2d23eb66ee',
  },
  {
    Hostname: 'flureshgr01',
    Name: 'Fluresh - Grand Rapids',
    ID: '14811d7c-eec3-4b64-bec6-2c459538d2b7',
  },
  {
    Hostname: 'forever420ny',
    Name: 'Forever 420',
    ID: 'ad1b7791-38a4-4d88-93ea-00b8a566e16f',
  },
  {
    Hostname: 'fstreet',
    Name: 'Davis',
    ID: '7387072f-68af-45f9-a3f2-b1fcd88e5e03',
  },
  {
    Hostname: 'ftesandbox',
    Name: 'FTE sandbox',
    ID: 'cdc9a317-dfb1-43dc-b842-a1eaf9d40746',
  },
  {
    Hostname: 'g2',
    Name: 'G2 Dispensary - Rockaway Borough',
    ID: '35a5b629-806f-47c1-8d09-7bc6a995d0da',
  },
  {
    Hostname: 'galaxy1',
    Name: 'Galaxy - Richton Park',
    ID: '0b2ec468-8c9c-4798-ac7a-4b6d45eac06b',
  },
  {
    Hostname: 'galaxygreens',
    Name: 'Galaxy Greens',
    ID: 'ce583511-88aa-4ccd-97ab-838bcc8c03f3',
  },
  {
    Hostname: 'gasandgrass',
    Name: 'Gas and Grass',
    ID: '2c3e1762-c3ae-4d66-862f-95a516d2004a',
  },
  {
    Hostname: 'gasstationwayland',
    Name: 'Gas Station - Wayland',
    ID: '9a7f79c9-19f1-4573-9aaf-ee6b6d9fd83a',
  },
  {
    Hostname: 'gdpsylmar',
    Name: 'Greenlight - Sylmar',
    ID: '161735ac-1286-4b94-b979-e0bee65386ea',
  },
  {
    Hostname: 'gfi',
    Name: "Earth's Healing - Tucson North",
    ID: '2bfdf762-76a7-4622-9a25-36bf115874d0',
  },
  {
    Hostname: 'ghc',
    Name: 'Greenhouse Herbal Center',
    ID: 'ca2cab26-4522-442c-9c0d-6b51468a72e1',
  },
  {
    Hostname: 'glwnv',
    Name: 'Greenleaf Wellness - Sparks',
    ID: '24289c65-6c6d-43e5-addc-01f710188c96',
  },
  {
    Hostname: 'goatglobalwla',
    Name: 'Goat Global - West LA',
    ID: 'eaa05b03-fc05-4e06-ae20-f205f93dc63d',
  },
  {
    Hostname: 'goe',
    Name: 'GoE - Hayward',
    ID: '725d8734-07b3-4f63-94ce-6c8deb6479c2',
  },
  {
    Hostname: 'goetracy',
    Name: 'GoE - Tracy',
    ID: '8ae7bf01-c3aa-4f69-8b0e-6662021f5ea0',
  },
  {
    Hostname: 'goldnbloomperris',
    Name: 'Goldn Bloom - Perris',
    ID: '2098a8b2-f261-429f-8b05-9f9c4f78bdbc',
  },
  {
    Hostname: 'goodiesstreamwood',
    Name: 'Goodies - Streamwood',
    ID: '84fc073c-1502-4329-bdb0-7c33c3d6a090',
  },
  {
    Hostname: 'gorillarx',
    Name: 'Gorilla RX - LA',
    ID: '329a71cd-c242-4435-835b-f67f166ece56',
  },
  {
    Hostname: 'grassroots',
    Name: 'Grass Roots - SF',
    ID: '24e26b9a-e903-44a9-9fb9-c7bfe4ee13f5',
  },
  {
    Hostname: 'greengoddess',
    Name: 'Green Goddess - Venice',
    ID: 'eb2eb192-4d87-4ce9-aaa1-958788be5881',
  },
  {
    Hostname: 'greenhalo',
    Name: 'The Green Halo - Tucson',
    ID: 'ff6accb4-73ac-4cf2-a850-5b48c31d9b4a',
  },
  {
    Hostname: 'greenhouseflagstaff',
    Name: 'Green House - Flagstaff',
    ID: '984c37c4-d88e-479e-976a-ecf1fa220ebf',
  },
  {
    Hostname: 'greenhouseny',
    Name: 'Greenhouse - New York',
    ID: '8a6b71f1-8741-47e9-aa1b-458643ca9705',
  },
  {
    Hostname: 'greenkoidouglas',
    Name: 'Green Koi - Douglas',
    ID: 'c61724af-926e-413c-a6cc-dd7db888a1bc',
  },
  {
    Hostname: 'greenlightnj',
    Name: 'Greenlight Apothecary',
    ID: '7ee1803c-c7a9-4cef-97fb-7c913d04ca23',
  },
  {
    Hostname: 'greenmartsa',
    Name: 'Green Mart Santa Ana',
    ID: 'f1b65017-589b-46c8-9b7d-502e549cf5ae',
  },
  {
    Hostname: 'greenpearl',
    Name: 'Green Pearl - Desert Hot Springs',
    ID: 'bdfb2b7e-f723-451f-8a41-eca8d0405928',
  },
  {
    Hostname: 'greenqweendtla',
    Name: 'Green Qween - DTLA',
    ID: '08c3c03e-b496-4324-a078-df9199e96743',
  },
  {
    Hostname: 'greenqweenweho',
    Name: 'Green Qween - WeHo',
    ID: '03108be3-3084-4dd8-ba69-58d79c37558f',
  },
  {
    Hostname: 'greensoulcam',
    Name: 'GreenSoul Cambridge',
    ID: 'c7b98b5f-53dc-48e5-be1a-75ae345000a2',
  },
  {
    Hostname: 'groverbeachnhc',
    Name: 'Grover Beach - NHC',
    ID: '7f7b676c-dfe6-4c28-800c-4aeceecff480',
  },
  {
    Hostname: 'gspc',
    Name: 'Golden State Patient Care - Colfax',
    ID: '0c58f698-889c-466b-8e32-69bf3b454d05',
  },
  {
    Hostname: 'gt',
    Name: 'Giving Tree Wellness Center',
    ID: '8e7d7ed2-cb4d-4aa7-9c70-2fd5f90e8135',
  },
  {
    Hostname: 'gtrc',
    Name: 'Green Tree Relief - Coldwater',
    ID: '5ce6b32a-4177-4f7d-b655-699d4815116e',
  },
  {
    Hostname: 'gtrr',
    Name: 'Green Tree Relief - Reading',
    ID: '0d74dc60-67aa-4b25-865a-0278aa9ee248',
  },
  {
    Hostname: 'gtwms1',
    Name: 'Green Tree - Vicksburg',
    ID: 'fefac5fd-0d72-45d9-9c17-b704ac318be1',
  },
  {
    Hostname: 'gwleaf',
    Name: 'GW Leaf',
    ID: 'b7d3bb73-fe13-4742-bf99-927389cd4187',
  },
  {
    Hostname: 'h80d',
    Name: 'Dixon',
    ID: '13264087-a272-4d9c-a2af-61437f5a98c4',
  },
  {
    Hostname: 'ha2',
    Name: 'Caliva - Hanford',
    ID: 'a5a7eb86-8184-4ebc-80d3-6ff2a0626b6b',
  },
  {
    Hostname: 'hanagv',
    Name: 'Hana Meds Green Valley',
    ID: 'd4308ca3-b8ba-4092-bca2-c570fb588fa4',
  },
  {
    Hostname: 'hanaphx',
    Name: 'Hana Meds - Phoenix',
    ID: '00d16e79-2369-47b8-959f-d47dc2832030',
  },
  {
    Hostname: 'harborcollective',
    Name: 'Harbor Collective - San Diego',
    ID: '3fe07cf8-a38f-45e6-a302-c398051a03bf',
  },
  {
    Hostname: 'harvestcorner',
    Name: 'Harvest Corner - Banning',
    ID: '4295cf92-ea0d-47d5-93f6-468b7c1a8a1a',
  },
  {
    Hostname: 'harvestsanpedro',
    Name: 'Harvest - San Pedro',
    ID: '02609252-cef2-4506-8b72-616dc4eec0aa',
  },
  {
    Hostname: 'harvestsantamonica',
    Name: 'Harvest - Santa Monica',
    ID: '4e1faf11-b4e4-4f32-8427-855baeace51a',
  },
  {
    Hostname: 'hasheesh',
    Name: 'Hasheesh - Big Rapids',
    ID: 'f9c02865-ffec-4ddd-aa8f-c159c2081f81',
  },
  {
    Hostname: 'haze',
    Name: 'Haze - Almaden Rd',
    ID: '12747dc2-22dd-431c-9216-67eb9e60fd12',
  },
  {
    Hostname: 'hazesaratoga',
    Name: 'Haze - Saratoga Ave',
    ID: '56e12586-3781-467b-8d92-ebf8fb80ff76',
  },
  {
    Hostname: 'hcharrisville',
    Name: 'Highly Cannaco - Harrisville',
    ID: 'd3e5d54e-bff7-4637-b89b-ceb1f122ec9b',
  },
  {
    Hostname: 'herbalwellness',
    Name: 'Herbal Wellness',
    ID: '961dc70c-f3cf-4ce7-954a-79ebc8697cdd',
  },
  {
    Hostname: 'herbankultureoc',
    Name: 'Herban Kulture - Santa Ana',
    ID: 'b9eaa2f4-ab1a-489a-aa55-a1838ce50859',
  },
  {
    Hostname: 'herbnjoychula',
    Name: 'HerbNJoy - Chula Vista',
    ID: '4fe90b2b-3c10-4a0e-8917-133759b5ab6b',
  },
  {
    Hostname: 'herbnjoyhanford',
    Name: 'HerbNJoy - Hanford',
    ID: '42b06a49-056e-4a80-8191-3938f5834221',
  },
  {
    Hostname: 'herbnjoywalnutcreek',
    Name: 'HerbNJoy - Walnut Creek',
    ID: '188d59f6-1359-4d92-a8db-15b5fe86c430',
  },
  {
    Hostname: 'herbsocial',
    Name: 'Herb Social - Lawrenceville',
    ID: '98ec2989-46ab-4ab0-8fc5-ce72026f607d',
  },
  {
    Hostname: 'heyaparkhills',
    Name: 'Heya Wellness- Park Hills',
    ID: '7789dbea-03f1-4af8-855d-f029c411f955',
  },
  {
    Hostname: 'heyastann',
    Name: 'Heya Wellness- Saint Ann',
    ID: 'ab943a83-f971-45c6-943e-94a5582f7878',
  },
  {
    Hostname: 'heyastcharles',
    Name: 'Heya Wellness- St. Charles',
    ID: '77cc8869-48d5-469d-923e-f86f5dcff317',
  },
  {
    Hostname: 'hf1',
    Name: 'Harbor Farmz - Three Rivers',
    ID: 'fb92b63c-067e-4a2b-bac0-b28656e4e3a9',
  },
  {
    Hostname: 'hf2',
    Name: 'Harbor Farmz - Charlotte',
    ID: '5ff0b1fb-e613-4ae7-bd7f-18f72238d78b',
  },
  {
    Hostname: 'hibrid',
    Name: 'HiBrid - Pittsfield',
    ID: 'abb16477-14ab-4378-8a32-eff6379e64c6',
  },
  {
    Hostname: 'hierba',
    Name: 'Hierba - LA',
    ID: 'b8d35eec-9d0e-4e7f-a266-5c7df222f9cc',
  },
  {
    Hostname: 'hifidelity',
    Name: 'Hi Fidelity - Berkeley',
    ID: '4a38e017-86c2-4233-894c-4135c98609e9',
  },
  {
    Hostname: 'higherground',
    Name: 'Higher Ground - San Bernardino',
    ID: '58ebe688-8409-42a5-9202-b917d6165815',
  },
  {
    Hostname: 'highergroundbp',
    Name: 'Higher Ground - Baldwin Park',
    ID: 'c03de562-36dc-4291-b60b-810b06d1655a',
  },
  {
    Hostname: 'highergroundlw',
    Name: 'Higher Ground - Lynwood',
    ID: '17801a28-612e-4bf7-aef1-8daa75a0a565',
  },
  {
    Hostname: 'highergroundmv',
    Name: 'Higher Ground - Moreno Valley',
    ID: '95b1ae45-b5db-4a79-8081-7c980fd8f403',
  },
  {
    Hostname: 'highstakesleafery',
    Name: 'High Stakes Leafery',
    ID: '7f9ce985-6e8a-4fea-bb58-371ccac53aba',
  },
  {
    Hostname: 'highstandardsparta',
    Name: 'High Standard - Sparta',
    ID: '79178b46-7f24-4165-837f-fd8bad59d256',
  },
  {
    Hostname: 'hightend',
    Name: 'Hightend - Palm Springs',
    ID: '8193bdf1-911b-4664-a489-b6845e0da3c0',
  },
  {
    Hostname: 'hikei',
    Name: 'Hikei - City Heights',
    ID: 'c53d5f05-b530-453d-83fb-f179fad8bd98',
  },
  {
    Hostname: 'hikeigrossmont',
    Name: 'Hikei - Grossmont',
    ID: '5213631c-e62c-46ef-9f91-d51a1447f066',
  },
  {
    Hostname: 'hikersmi',
    Name: 'Hikers - White Cloud',
    ID: 'f12570f4-0804-4ee6-9d77-7a60cd2bd9d4',
  },
  {
    Hostname: 'hlcarmel',
    Name: 'Higher Level - Carmel',
    ID: '8b4ed66b-4373-47eb-9338-aaf16f235c1b',
  },
  {
    Hostname: 'hlgreenfield',
    Name: 'Higher Level - Greenfield',
    ID: '6988949b-8456-419b-883f-eaa744c2b4c2',
  },
  {
    Hostname: 'hlhollister',
    Name: 'Higher Level - Hollister',
    ID: '074727d4-131e-47fd-8090-a4970226ba43',
  },
  {
    Hostname: 'hlseaside',
    Name: 'Higher Level - Seaside',
    ID: 'b30d8deb-7a2e-4f60-9887-aac5847b3859',
  },
  {
    Hostname: 'holisticreleafnj',
    Name: 'Holistic Re-Leaf - Rockaway',
    ID: 'd5b53bb3-79d9-476c-aac5-0d93c601dee5',
  },
  {
    Hostname: 'hotboxnr',
    Name: 'HIGH. - Northridge',
    ID: 'd1b62e97-1f48-4b0f-a2b9-b01299d4c43c',
  },
  {
    Hostname: 'houseofermias',
    Name: 'House of Ermias - Chelsea',
    ID: '636e3e56-896f-41a1-91f9-9da29001751b',
  },
  {
    Hostname: 'hpc',
    Name: 'HPC - Port Hueneme',
    ID: '6aa4cbba-bb47-4005-94f8-bc0b4c889c7b',
  },
  {
    Hostname: 'hrdispensary',
    Name: 'Highlands Reserve - Perris',
    ID: 'e08d5c27-1f80-4b49-8b23-a149d3c415a1',
  },
  {
    Hostname: 'hudhaus',
    Name: 'HudHaus',
    ID: 'f2342b88-fee2-4d3f-94a5-c000f3356302',
  },
  {
    Hostname: 'illacanna',
    Name: 'ILLA Canna - Jefferson',
    ID: '8cda43c5-84c4-4119-9c1a-f13ed82b8cdd',
  },
  {
    Hostname: 'illacannanoho',
    Name: 'ILLA Canna - North Hollywood',
    ID: '5e193bfb-dcd5-48ee-85e8-4e4aa40163a6',
  },
  {
    Hostname: 'indoor',
    Name: 'Indoor Treez NYC',
    ID: 'ad665be6-5767-4795-87b4-934c1213e231',
  },
  {
    Hostname: 'inyo',
    Name: 'Inyo Fine Cannabis',
    ID: '8663db20-ebed-45e6-bb32-3bc55e0df01f',
  },
  {
    Hostname: 'jaderoom',
    Name: 'Jaderoom - Torrance',
    ID: '92934171-81c3-45d6-95e6-8f95eebf5a80',
  },
  {
    Hostname: 'jaderoomoc',
    Name: 'Jaderoom - Santa Ana',
    ID: '08abf989-78c5-4094-80e5-5e5394bc9284',
  },
  {
    Hostname: 'jardin-lv',
    Name: 'Jardin Premium Cannabis',
    ID: 'b7b61901-80cf-4d77-af23-a934f92150a0',
  },
  {
    Hostname: 'jj-glassboro',
    Name: 'Jersey Joint - Glassboro',
    ID: 'f76735a3-4d91-49c5-900d-4d91aa4716d5',
  },
  {
    Hostname: 'jopsgardner',
    Name: 'Joint Operations- Gardner',
    ID: 'ba347966-8dd7-42b6-b363-bbf5a5002370',
  },
  {
    Hostname: 'jopsmendon',
    Name: 'Joint Operations- Mendon',
    ID: '159a0e30-c9e1-4387-8c6d-2419295c33cd',
  },
  {
    Hostname: 'jopsrowley',
    Name: 'Joint Operations- Rowley',
    ID: '2e681a43-99c5-43cd-9f51-a0aa5f4ca4cd',
  },
  {
    Hostname: 'juvarwc',
    Name: 'Juva Life',
    ID: '32f907b5-e2cf-4ef2-a9dc-f6ff4d0dc593',
  },
  {
    Hostname: 'jv',
    Name: 'Depot Town - Ypsilanti',
    ID: 'd529ac0f-8268-4028-aa08-9d4896cbd3c0',
  },
  {
    Hostname: 'kclb',
    Name: "King's Crew - Long Beach",
    ID: 'a75108bf-1101-447b-918e-240a4be82a0f',
  },
  {
    Hostname: 'kentreserve',
    Name: 'Kent Reserve',
    ID: 'bc2ba7c0-3602-4450-b8e7-15db1c050401',
  },
  {
    Hostname: 'kindkush-nj',
    Name: 'Kind Kush',
    ID: '04906cae-e6b2-4bda-8e0c-e2f3232e8ccd',
  },
  {
    Hostname: 'kinebudsnj',
    Name: 'Kine Buds NJ',
    ID: '9af7609e-c64a-466e-9627-4fb3cc18eb0b',
  },
  {
    Hostname: 'kingstoncannabisny',
    Name: 'Kingston Cannabis NY- DBA HUB DISPENSARY',
    ID: 'b462a856-85f6-4ce6-8d0b-ff033c152780',
  },
  {
    Hostname: 'klover',
    Name: 'Klover - San Diego',
    ID: 'fcae97b5-1bf6-45d7-bb22-0f7fde8d3199',
  },
  {
    Hostname: 'kushkabana',
    Name: 'Kush Kabana',
    ID: '3f1b1d98-7900-408f-a8ca-ce1c7b6d7863',
  },
  {
    Hostname: 'la2',
    Name: 'Coastal - West LA',
    ID: 'dfaabb1d-1ecc-44d8-a1ac-89b83e46e2ea',
  },
  {
    Hostname: 'lapcg',
    Name: 'LAPCG - West Hollywood',
    ID: 'c768a2a8-3616-4b51-8f50-e10049c49b83',
  },
  {
    Hostname: 'latitudeeldon',
    Name: 'Latitude - Eldon',
    ID: '70c3a008-d460-4c7c-b1bd-623ce9ad6610',
  },
  {
    Hostname: 'latitudeosage',
    Name: 'Latitude - Osage Beach',
    ID: '29d110b1-b381-4b9c-92c9-ede9c326d0a5',
  },
  {
    Hostname: 'lbcollective',
    Name: 'LB Collective',
    ID: '5aebd42c-f82b-4eac-a9ee-651dee15d1af',
  },
  {
    Hostname: 'leafelpaseo',
    Name: 'Leaf El Paseo',
    ID: '0fab7505-1a8b-43cb-873d-485cb3447d98',
  },
  {
    Hostname: 'leafsocietyelcentro',
    Name: 'Leaf Society - El Centro',
    ID: '5f1c0221-1381-4e09-9a4c-6577f8f188e4',
  },
  {
    Hostname: 'leafsocietyss',
    Name: 'Leaf Society - Salton Sea',
    ID: '169a1211-b1d5-41f0-a9fc-825af11c8159',
  },
  {
    Hostname: 'leafywonders',
    Name: 'Leafy Wonders',
    ID: 'ca100bc5-3a23-433d-a17d-105138f9762a',
  },
  {
    Hostname: 'lefcannabisco',
    Name: 'Lēf Cannabis Co.',
    ID: 'a53c605f-f3d4-4611-b2f2-f16dffde1e20',
  },
  {
    Hostname: 'lemonnadearleta',
    Name: 'Lemonnade - Arleta',
    ID: 'f891a9d0-f46a-48c7-986d-b689da381ba0',
  },
  {
    Hostname: 'lemonnadesac',
    Name: 'Lemonnade - Sac',
    ID: '437f5ae6-ada4-40c0-be92-5a9279ca76c6',
  },
  {
    Hostname: 'lemonnadesouthsac',
    Name: 'Lemonnade - South Sac',
    ID: '40c21b75-a548-4c3f-87c9-d23a9f00011f',
  },
  {
    Hostname: 'lemoorenhc',
    Name: 'Lemoore - NHC',
    ID: '3c102e34-271a-464c-968d-473827b96e08',
  },
  {
    Hostname: 'litlamesa',
    Name: 'La Mesa Health Center',
    ID: 'c459effa-bc22-40cb-837a-251748aedc10',
  },
  {
    Hostname: 'localroots',
    Name: 'East Boston Cannabis Co.',
    ID: 'b3189d60-aef9-4558-942d-9e8f3c27c033',
  },
  {
    Hostname: 'lokey',
    Name: 'Lo Key Delivery',
    ID: 'c69fd9eb-4454-4c45-9306-d9eeb55f794d',
  },
  {
    Hostname: 'lottafarm',
    Name: 'Farmstand',
    ID: '37f218d4-5370-491b-9388-56ce9538ced6',
  },
  {
    Hostname: 'mainstagedavis',
    Name: 'Mainstage - Davis',
    ID: 'a03f0eac-3ca7-4d6e-9ea4-2181fb090015',
  },
  {
    Hostname: 'mainstagesac',
    Name: 'Mainstage - Sac',
    ID: 'c0d51523-9379-4aa7-bb14-1dfb053640b9',
  },
  {
    Hostname: 'malibucc',
    Name: 'Malibu CC',
    ID: '276cf38b-60ab-4037-9cb1-f0892cd0ece5',
  },
  {
    Hostname: 'mammothholistics',
    Name: 'Mammoth Holistics',
    ID: '43deea5d-9abb-4f9f-9296-f36a407dbd88',
  },
  {
    Hostname: 'mammothroots',
    Name: 'Mammoth Roots',
    ID: '9207d8a8-dce3-46cb-b5a5-3ba73cf8fbd2',
  },
  {
    Hostname: 'mankind',
    Name: 'Mankind - San Diego',
    ID: '9c75bc8b-53e9-402a-885e-43b19ef5c1fb',
  },
  {
    Hostname: 'market96chicago',
    Name: 'Market 96 - Chicago',
    ID: '8a1808cd-038f-4c7a-962c-a67afe85f14a',
  },
  {
    Hostname: 'market96oswego',
    Name: 'Market 96 - Oswego',
    ID: 'd01e7451-5a14-461f-a731-37536487cd50',
  },
  {
    Hostname: 'maryjaneny',
    Name: 'Mary Jane Cannabis',
    ID: '588c3df1-5cc9-40f9-ad71-bbca8085790c',
  },
  {
    Hostname: 'medithrive',
    Name: 'Medithrive - SF',
    ID: 'c8532bbc-f2a7-4a93-b5dd-cda85209b1e9',
  },
  {
    Hostname: 'medleaf',
    Name: 'MedLeaf - Egg Harbor City',
    ID: 'cb1be30e-8978-40d1-86bb-cd24562bda26',
  },
  {
    Hostname: 'medscafeaa',
    Name: 'Meds Cafe - Ann Arbor',
    ID: '97579274-ab54-495c-b1da-281b8a78bf7b',
  },
  {
    Hostname: 'medscafealpena',
    Name: 'Meds Cafe - Alpena',
    ID: '4c055566-a14e-44ea-869b-0ce1fcf19618',
  },
  {
    Hostname: 'medscafecheboygan',
    Name: 'Meds Cafe - Cheboygan',
    ID: 'c4c86fab-bcea-46a2-93cc-7b504b0d4423',
  },
  {
    Hostname: 'medscafegaylord',
    Name: 'Meds Cafe - Gaylord',
    ID: 'dfe404e3-73fd-4462-ba10-c7acb84dbbfd',
  },
  {
    Hostname: 'medscafelowell',
    Name: 'Meds Cafe - Lowell',
    ID: '80436543-5760-4c8f-8142-46fd74cac212',
  },
  {
    Hostname: 'medscafemanistee',
    Name: 'Meds Cafe - Manistee',
    ID: '5292d747-2be6-431e-ac40-c66a772ac8f5',
  },
  {
    Hostname: 'medscaferc',
    Name: 'Meds Cafe - Rogers City',
    ID: '20a43676-5ce4-47b3-9544-2668d725f0fb',
  },
  {
    Hostname: 'mercywellness',
    Name: 'Mercy Wellness - Cotati',
    ID: 'f01c08f9-30ed-4900-85ee-04e8318992af',
  },
  {
    Hostname: 'mercywellnesssantarosa',
    Name: 'Mercy Wellness - Santa Rosa',
    ID: '531155f3-f7c4-4dde-b77b-278e0cdf33df',
  },
  {
    Hostname: 'metrocannabis',
    Name: 'Metro Cannabis - Sac',
    ID: 'ac1ac7c9-eb0e-4f2c-ae0f-c2d6276aa113',
  },
  {
    Hostname: 'mhd',
    Name: 'Mile High Dispensary',
    ID: '2ff050d7-afa9-4312-83ef-7916e5bd264a',
  },
  {
    Hostname: 'midnightgreensnj',
    Name: 'Midnight Greens - Turnersville',
    ID: '4c599590-b4d2-4ec9-96f6-7ce1e73d3de7',
  },
  {
    Hostname: 'mindlift',
    Name: 'Mindlift Dispensary',
    ID: '88947785-ad3e-48b2-b265-12f9acbc4123',
  },
  {
    Hostname: 'mindsetny1',
    Name: 'Mindset Cannabis',
    ID: 'a27989d0-8fc1-40e1-8b49-b5014dc2ff31',
  },
  {
    Hostname: 'moegreens',
    Name: 'Moe Greens - SF',
    ID: '7c1290e4-f646-4caa-8c5e-688e7b02f620',
  },
  {
    Hostname: 'mom',
    Name: 'MOM - SLO',
    ID: '894c43ef-3abe-44fc-bd84-b4b5e9173a4e',
  },
  {
    Hostname: 'momcorona',
    Name: '',
    ID: '',
  },
  {
    Hostname: 'momelcentro',
    Name: '',
    ID: '',
  },
  {
    Hostname: 'momgoleta',
    Name: 'MOM - Goleta',
    ID: '1e25b7b2-de7f-45c8-91d0-f32430a36f11',
  },
  {
    Hostname: 'moonflower',
    Name: 'Moonflower Delivery - San Rafael',
    ID: '2bb54820-3d0b-4330-a625-8cf5c5724b89',
  },
  {
    Hostname: 'morrobaynhc',
    Name: 'Morro Bay - NHC',
    ID: '217a72f1-0e2d-49b2-a6da-da6959005be7',
  },
  {
    Hostname: 'mountain-nj',
    Name: 'Mountain Dispensary',
    ID: '1c02da30-91eb-4323-8c57-cdf504686aac',
  },
  {
    Hostname: 'mrgoodvybz',
    Name: 'Mr. Good Vybz',
    ID: 'fb2a72e7-c6d1-489c-ad86-c9262bbe39a1',
  },
  {
    Hostname: 'mystika',
    Name: 'Mystika Cannabis',
    ID: '1eadc8c9-e8f8-4727-b2aa-f81dc1fec78d',
  },
  {
    Hostname: 'namaste',
    Name: 'Namaste Cannabis - Naperville',
    ID: 'b123ded8-71b0-42ba-9839-7519e26580ca',
  },
  {
    Hostname: 'natrlhi',
    Name: 'NATRL HI - Sacramento',
    ID: 'eedc7a37-7844-48d8-bbe5-a5e65ed7863b',
  },
  {
    Hostname: 'naturesreleafbur',
    Name: "Nature's Releaf - Burton",
    ID: 'd309f997-f0c3-4fd5-a185-da3f3cdc530f',
  },
  {
    Hostname: 'naturesreleafgr',
    Name: "Nature's Releaf - Grand Rapids",
    ID: '17931a69-c977-42e1-8c24-43d9536cc0e6',
  },
  {
    Hostname: 'nelard',
    Name: 'Nela Rd',
    ID: 'b22892a6-5b8c-4458-8cef-4ec4acbc6fa2',
  },
  {
    Hostname: 'nelard2',
    Name: 'Nela Rd #2',
    ID: '502edf6c-b6db-4dec-8636-06feac84757c',
  },
  {
    Hostname: 'nevaeh',
    Name: 'Nevaeh Verde',
    ID: 'aafff8d0-d065-4c9b-81b8-eec5b5f5308a',
  },
  {
    Hostname: 'newamsterdam',
    Name: 'New Amsterdam Naturals - LA',
    ID: '34408afd-713a-4d9c-8ade-302840940a07',
  },
  {
    Hostname: 'newera',
    Name: 'New Era Dispensary',
    ID: '4f24d38f-61c2-4a2e-a55c-382c31280247',
  },
  {
    Hostname: 'newfrontier',
    Name: 'New Frontier Solutions - Vineland',
    ID: '6ab1a0b2-9366-4ba5-b5b2-812199f48d61',
  },
  {
    Hostname: 'nirvana-lakezurich',
    Name: 'Nirvana Dispensary - Lake Zurich',
    ID: '2e5af528-0f01-49f5-bfac-c0189747f2f7',
  },
  {
    Hostname: 'nirvana-lawrence',
    Name: 'Nirvana Dispensary - Lincoln Square',
    ID: '263d5fd8-7d3f-4135-bb73-329d09c2c6bb',
  },
  {
    Hostname: 'nirvana-mtcarmel',
    Name: 'Nirvana Dispensary - Mount Carmel',
    ID: '14459f8d-68df-4d96-8a1f-f119f092c265',
  },
  {
    Hostname: 'nirvana-palatine',
    Name: 'Nirvana Dispensary - Palatine',
    ID: 'c4f1ed9a-d6f3-4c09-8bff-78bdc037a946',
  },
  {
    Hostname: 'nirvana7th',
    Name: 'Nirvana 7th Street',
    ID: 'de797542-2f56-46b2-a44d-87629aaf9f30',
  },
  {
    Hostname: 'nirvananj',
    Name: 'Nirvana - Mt Laurel',
    ID: 'f101611a-d81f-470a-bf64-8d8d8de58a30',
  },
  {
    Hostname: 'nobodyshome',
    Name: "Nobody's Home - Benton Harbor",
    ID: '883efc81-c857-4180-be71-28f585ce4273',
  },
  {
    Hostname: 'northbeachpipeline',
    Name: 'North Beach Pipeline - SF',
    ID: '0a46dab9-7614-42ea-b10e-963cb09b18e8',
  },
  {
    Hostname: 'nova',
    Name: 'Nova Dispensary',
    ID: '099e3add-0df0-4205-a3d0-b2f6b6ae771c',
  },
  {
    Hostname: 'nprovisions',
    Name: 'Neighborhood Provisions - Alpena',
    ID: '74d51a11-6ed1-491d-b74d-947667a74d2a',
  },
  {
    Hostname: 'nugalameda',
    Name: 'NUG - Alameda',
    ID: 'd4472f68-9f28-49d0-85b3-767366d179c9',
  },
  {
    Hostname: 'nugelcerrito',
    Name: 'NUG - El Cerrito',
    ID: '33cc3c60-fca5-4456-8dc6-e3c9cd319c2e',
  },
  {
    Hostname: 'nugghubb-lakeelsinore',
    Name: 'Nugg Hubb Lake Elsinore',
    ID: '4fd7210b-f35d-45c5-bb4f-cb67b8f4d21d',
  },
  {
    Hostname: 'nugoak',
    Name: 'NUG - Oakland',
    ID: '6b63a94e-22da-463e-9a65-014eb5b5670b',
  },
  {
    Hostname: 'nugps',
    Name: 'NUG - Palm Springs',
    ID: '7ce70485-db27-45e5-b55e-74fa9cae9af6',
  },
  {
    Hostname: 'nugrb',
    Name: 'NUG - Red Bluff',
    ID: '516301ff-cdcf-4152-8c5f-12910cbc64e6',
  },
  {
    Hostname: 'nugriovista',
    Name: 'Nug - Rio Vista',
    ID: '61bc853d-bc9e-448f-a36b-a3a21ea4a671',
  },
  {
    Hostname: 'nugsac',
    Name: 'NUG - Sac',
    ID: '1400ece2-63fc-4c7d-bb84-950968080f40',
  },
  {
    Hostname: 'nugsl',
    Name: 'NUG - San Leandro',
    ID: '3c80700e-403f-434d-81f5-5212feecac2a',
  },
  {
    Hostname: 'nugsr',
    Name: 'NUG Santa Rosa',
    ID: '6e23b7e8-4a84-45df-800d-76b42bcde3fe',
  },
  {
    Hostname: 'nugvallejo',
    Name: 'NUG - Vallejo',
    ID: '7fb56387-a9a0-42a9-a131-9cb1c42dd05a',
  },
  {
    Hostname: 'nugyonkers',
    Name: 'NUG - Yonkers',
    ID: 'b6c7e8d7-41d2-4706-95b9-d8042e91f7e4',
  },
  {
    Hostname: 'nuwu',
    Name: 'NuWu - Main',
    ID: '52c85f98-f49b-4685-a358-adbcfc387c38',
  },
  {
    Hostname: 'nuwugiftshop',
    Name: 'NuWu - Main Gift Shop',
    ID: '3e1d8683-5ffb-4544-8bdc-f2fd187fcded',
  },
  {
    Hostname: 'nuwunorth',
    Name: 'NuWu - North',
    ID: '86eda4bb-df5f-45e4-8342-811c388fe566',
  },
  {
    Hostname: 'nuwunorthgiftshop',
    Name: 'NuWu - North Gift Shop',
    ID: '548131f6-7cbd-45a9-ae03-80ad26958d6f',
  },
  {
    Hostname: 'oakfruitlandccc',
    Name: 'Oakfruitland - Capitola',
    ID: '8fc6a92c-e23a-45fd-b2e8-5ec38076610c',
  },
  {
    Hostname: 'oakfruitlandsf',
    Name: 'Oakfruitland - San Francisco',
    ID: '0a5f5995-52b1-42b7-a93a-994fafc0c003',
  },
  {
    Hostname: 'obsidian',
    Name: 'Obsidian',
    ID: '8d4c4853-2127-48f7-8f52-b16f701529f6',
  },
  {
    Hostname: 'oc3',
    Name: 'Catalyst - OC3',
    ID: '18a8cf55-211a-48db-819e-0149adac1b92',
  },
  {
    Hostname: 'ohanacannabisbeverlyhills',
    Name: 'Ohana - Los Angeles',
    ID: '3e25f1f9-5fd0-4c3d-81ae-23f0fd343e26',
  },
  {
    Hostname: 'ohanacannabisoakland',
    Name: 'Ohana - Oakland',
    ID: 'efb44aab-b932-4392-b800-7f4551ab285a',
  },
  {
    Hostname: 'ohanacannabissantacruz',
    Name: 'Ohana - Santa Cruz',
    ID: '59ba9950-d563-4d1e-9a40-b5be03da574a',
  },
  {
    Hostname: 'ojaigreens',
    Name: 'Ojai Greens',
    ID: 'e5e063ac-40b4-4662-ae1a-2cc714677491',
  },
  {
    Hostname: 'onlyalien',
    Name: 'Only Alien - Kalamazoo',
    ID: 'd957c309-8461-40c9-ae6b-2ba497d2a5c0',
  },
  {
    Hostname: 'opuntiadelaware',
    Name: 'Opuntia - Delaware',
    ID: '5d192ac8-c508-43c5-b583-3b5911054581',
  },
  {
    Hostname: 'opuntiaenglewood',
    Name: 'Opuntia - Englewood',
    ID: '0ab63ffd-40f5-4acf-9baa-d8353ca37c22',
  },
  {
    Hostname: 'originalshof',
    Name: 'HOF Instance',
    ID: 'f7435fac-e6ee-48e9-8683-80229f5d335e',
  },
  {
    Hostname: 'originalslosangeles',
    Name: 'Originals Factory and Weed',
    ID: '326a576e-f55f-4076-9b68-7e6899582c08',
  },
  {
    Hostname: 'originalssandiego',
    Name: 'Originals - San Diego',
    ID: '0253314e-4894-4a11-9f60-8d299b7e40f1',
  },
  {
    Hostname: 'outpostsantarosa',
    Name: 'The Outpost - Santa Rosa',
    ID: 'c42857a3-cb9f-4f57-a922-a3e3bead9a6e',
  },
  {
    Hostname: 'oxnardholistics',
    Name: 'Oxnard Holistics',
    ID: '4fef6b7f-a2af-4a02-b303-865afa0350f0',
  },
  {
    Hostname: 'pa1',
    Name: 'Varda - Pasadena',
    ID: '611b4d0d-e627-4baf-9f07-24701e135742',
  },
  {
    Hostname: 'pegasus',
    Name: 'Pegasus - Jackson',
    ID: '0520661e-55f9-4312-8a06-2266385745ea',
  },
  {
    Hostname: 'perception',
    Name: 'Perception Cannabis - Chicago',
    ID: '00916243-e6b0-4370-a370-9f8038ed96f6',
  },
  {
    Hostname: 'perfectunionmb',
    Name: 'Perfect Union -  Morro Bay',
    ID: '2e32e7e3-6644-4261-b582-4ff1e87d34e8',
  },
  {
    Hostname: 'perfectunionmv',
    Name: 'Perfect Union - Marysville',
    ID: '3bd7a56c-59eb-488f-8728-c831662718d5',
  },
  {
    Hostname: 'perfectunionnapa',
    Name: 'Perfect Union - Napa',
    ID: 'abba5475-6342-4e04-9f12-1689fb95a624',
  },
  {
    Hostname: 'perfectunionsaces',
    Name: 'Perfect Union - Sac Eastside',
    ID: '0f543b86-bddc-46e0-8993-fce1f0776d8a',
  },
  {
    Hostname: 'perfectunionsacns',
    Name: 'Perfect Union - Sac NorthSide',
    ID: 'ec400855-f9f2-44dc-8424-ba6ef8688b03',
  },
  {
    Hostname: 'perfectunionsandiego',
    Name: 'Perfect Union - San Diego',
    ID: '82c9129d-ecd5-4235-8ff8-3d859b6284dc',
  },
  {
    Hostname: 'perfectunionshasta',
    Name: 'Perfect Union - Shasta',
    ID: '4eda7743-7fc7-4607-a320-0448abb59397',
  },
  {
    Hostname: 'perfectunionturlock',
    Name: 'Perfect Union - Turlock',
    ID: 'dc85fdbd-f4f1-4ef8-8b6d-2337ba79f48a',
  },
  {
    Hostname: 'perfectunionweed',
    Name: 'Perfect Union - Weed',
    ID: 'f2e688bd-fc80-4766-aa80-e0c5a436a4d8',
  },
  {
    Hostname: 'perfectunionwoodland',
    Name: 'Perfect Union - Woodland',
    ID: 'c6e6c1d2-735b-4e1f-97a6-73ed081df960',
  },
  {
    Hostname: 'pharmhouse-gr',
    Name: 'Pharmhouse Wellness - Grand Rapids',
    ID: '37b5db2b-169d-4f8a-a54d-69f604cdb929',
  },
  {
    Hostname: 'pharmhouse-nb',
    Name: 'Pharmhouse Wellness - New Buffalo',
    ID: 'e1f0cab2-c0d3-4209-9e00-9c8c3837e790',
  },
  {
    Hostname: 'phenotopia',
    Name: 'Phenotopia - Santa Rosa',
    ID: '84cb6a87-42f3-4fe1-9680-72e8324dc05f',
  },
  {
    Hostname: 'phytologie',
    Name: 'Phytologie Wellness',
    ID: 'a5303b71-e54b-4b42-b182-433db3a3e97f',
  },
  {
    Hostname: 'planetbuds',
    Name: 'Planet Buds - San Jacinto',
    ID: 'bc165624-0b25-41bb-a969-d43308972e9c',
  },
  {
    Hostname: 'plantgalaxy',
    Name: 'Plant Galaxy - Riverside',
    ID: '06dcd297-ac2f-4c1e-acad-47478ab03965',
  },
  {
    Hostname: 'plantshop',
    Name: 'Plantshop - Ukiah',
    ID: '351753d3-c622-4fa7-8c12-bd060b314497',
  },
  {
    Hostname: 'platinumconnection',
    Name: 'Platinum Connection - Farmersville',
    ID: '8f1d89ff-8271-4f72-8f7a-e5c95eb7f73c',
  },
  {
    Hostname: 'pocket',
    Name: 'Pocket Dispensary',
    ID: '39fc7f03-2a2b-4a31-813f-f7428a9af664',
  },
  {
    Hostname: 'portolapipeline',
    Name: 'Portola Pipeline',
    ID: '72b327fa-7d78-45f2-b196-2bc52211f133',
  },
  {
    Hostname: 'prc',
    Name: 'Palm Royale - Palm Desert',
    ID: 'ffa9291b-1033-432d-84d2-aadf59607829',
  },
  {
    Hostname: 'prc3',
    Name: 'Palm Royale Collective - Cathedral City',
    ID: 'f7ca9650-938b-4ad9-9621-03e1eb31ae46',
  },
  {
    Hostname: 'prctoo',
    Name: 'Palm Royal Collective Hwy 111',
    ID: 'bb374635-b539-4bb4-91f8-0b69407fc0d2',
  },
  {
    Hostname: 'premium-blossom',
    Name: 'Premium Blossom',
    ID: '9e230c19-6ece-4ad3-a8ef-d42ee3174a4b',
  },
  {
    Hostname: 'prohibitionherb',
    Name: 'Prohibition Herb - Durango',
    ID: 'd70cb58b-dcf2-423c-a416-afcd3046f896',
  },
  {
    Hostname: 'properleaf-memphis',
    Name: 'Proper Leaf - Memphis',
    ID: '7ffa3003-a902-4f77-b1c9-f7f08b209bf1',
  },
  {
    Hostname: 'puffla',
    Name: 'Puff - LA',
    ID: 'ff69aa0a-edc8-452c-8790-7b6db92c1e1b',
  },
  {
    Hostname: 'purelife',
    Name: 'Pure Life Collective',
    ID: 'fa3aa6e7-5078-48b1-86a0-f7f8e350f346',
  },
  {
    Hostname: 'purplelotus',
    Name: 'Purple Lotus - San Jose',
    ID: '7b358141-b300-4dfa-9d1d-09a447830d27',
  },
  {
    Hostname: 'purplelotusdt',
    Name: 'Purple Lotus - Downtown',
    ID: '4902e8a3-1bb3-43ff-a7ae-045eb0132bb5',
  },
  {
    Hostname: 'purplemed',
    Name: 'Opuntia Cannabis - Broadway',
    ID: '14c37873-1e0c-48ab-8b91-81dc8b7a22f4',
  },
  {
    Hostname: 'qualitylife',
    Name: 'Quality Life - Barstow',
    ID: 'fd00d7db-ab41-44b5-ad52-e7a9141c8490',
  },
  {
    Hostname: 'r2h-le',
    Name: 'Roots 2 Harvest - Lake Elsinore',
    ID: '83095e28-bc83-4016-b50d-dcbc4b7ed7e2',
  },
  {
    Hostname: 'ramonacannabis',
    Name: 'Ramona Cannabis Co.',
    ID: '1ec2c681-f52d-4243-84d0-86d73b541b8b',
  },
  {
    Hostname: 'reddoorremedies',
    Name: 'Red Door Remedies',
    ID: '6efa419d-7efd-424f-85d5-b3892daf9582',
  },
  {
    Hostname: 'reefershop',
    Name: 'Reefer Shop',
    ID: '11fb0610-87b8-4b1a-bca5-2db37a0b579d',
  },
  {
    Hostname: 'refinery',
    Name: 'The Refinery - Kalamazoo',
    ID: '66df4b4e-84af-4ba0-ba30-d944372c2ff2',
  },
  {
    Hostname: 'refinerynewbuffalo',
    Name: 'The Refinery - New Buffalo',
    ID: '18812942-529b-4b8c-825c-8cec02afc321',
  },
  {
    Hostname: 'releafnewton',
    Name: 'Releaf Newton',
    ID: '44e6420d-25fe-4abc-97d2-23aed2ecc4fe',
  },
  {
    Hostname: 'reservebalboa',
    Name: 'The Reserve - Balboa',
    ID: '3014a065-ed1e-44e4-96b2-a7653fd15b54',
  },
  {
    Hostname: 'ript',
    Name: 'RIPT - Jersey City',
    ID: 'a03a5591-f483-43cd-a6e3-30b3cff0a714',
  },
  {
    Hostname: 'riverremedy-byram',
    Name: 'River Remedy - Byram',
    ID: '7ad4efa0-1f70-428d-ad32-f02616f4066a',
  },
  {
    Hostname: 'riverremedy-corinth',
    Name: 'River Remedy - Corinth',
    ID: '8b4622d9-b710-420a-b225-968cfddbd1a4',
  },
  {
    Hostname: 'riverremedy-herbalalchemy',
    Name: 'River Remedy - Herbal Alchemy',
    ID: '6e397680-3634-48c8-b7e8-dbcabbfa6567',
  },
  {
    Hostname: 'riverremedy-lighthouse',
    Name: 'River Remedy - Lighthouse',
    ID: '9b88e866-4906-4455-96e4-accd61329561',
  },
  {
    Hostname: 'riverremedy-pinebelt',
    Name: 'River Remedy - Pine Belt',
    ID: 'ea4dc238-b64d-4e97-b6d6-192dc29a42dc',
  },
  {
    Hostname: 'rizeim',
    Name: 'RiZE - Iron Mountain',
    ID: 'f407c88a-2be7-4d92-9bbe-432acdb29b3d',
  },
  {
    Hostname: 'rizeirw',
    Name: 'RiZE - Ironwood',
    ID: '01011c8a-9dc1-4494-af78-22686fd557c9',
  },
  {
    Hostname: 'rizemnm',
    Name: 'RiZE - Menominee',
    ID: 'bca27a52-d217-46c7-82cc-a48984365a43',
  },
  {
    Hostname: 'rizemqt',
    Name: 'RiZE - Marquette',
    ID: 'ae43c626-6f02-4fef-bb1d-04f93413805e',
  },
  {
    Hostname: 'rootd510',
    Name: "Root'd In 510",
    ID: '614fc489-22f8-4085-9a9e-30d011094417',
  },
  {
    Hostname: 'rooted',
    Name: 'Rooted In - Newbury St.',
    ID: 'e12df239-25f0-41c1-8164-6991a834a2c8',
  },
  {
    Hostname: 'rootsla',
    Name: 'Roots LA',
    ID: '4bb12b4b-c380-444e-a492-0a69b86c70d3',
  },
  {
    Hostname: 'rowhousesb',
    Name: 'Row House San Bernardino',
    ID: 'b98fef79-bc7f-4611-a78a-efc9411dab20',
  },
  {
    Hostname: 'rwc-airfield',
    Name: 'Airfield Supply Company - Redwood City',
    ID: 'ae3c7930-8fcc-498c-b00f-747b61ac28b1',
  },
  {
    Hostname: 'saddlebrooknj',
    Name: 'Dispensary of Saddlebrook',
    ID: '60932ea6-66ec-432d-9179-b2bb6e83a19f',
  },
  {
    Hostname: 'safeport',
    Name: 'Safeport - Port Hueneme',
    ID: '1b99923f-3138-4b6f-8c78-070a5d1f5bfb',
  },
  {
    Hostname: 'safeport-oxnard',
    Name: 'Safeport - Oxnard',
    ID: 'de3a0e77-12e0-4c72-99c1-fe24be6ea4e4',
  },
  {
    Hostname: 'sageandfire',
    Name: 'Sage & Fire - Lone Pine',
    ID: 'b036ddc5-6a72-4131-9d4a-957d30ce2012',
  },
  {
    Hostname: 'sandiegodgt',
    Name: "Dr. GreenThumb's - San Diego",
    ID: '5b3c663b-3101-48ba-880a-0621a58e4e6a',
  },
  {
    Hostname: 'sb2',
    Name: 'Coastal - Santa Barbara Retail',
    ID: '16ba013c-ca3d-4d3f-ae12-3c2a77975314',
  },
  {
    Hostname: 'scarletreserveroom',
    Name: 'Scarlet Reserve Room',
    ID: 'd53c8327-1a05-456c-9dbf-c62781271a05',
  },
  {
    Hostname: 'seaandleaf',
    Name: 'Sea & Leaf - Cape May',
    ID: 'a12d14af-a118-4950-8dce-1e066edff3c2',
  },
  {
    Hostname: 'serenity',
    Name: 'Serenity of Lathrop-Manteca',
    ID: 'c148ed2c-6895-440f-af88-45c79711282b',
  },
  {
    Hostname: 'sespecreek',
    Name: 'Sespe Creek - Ojai',
    ID: '21709cb8-1134-4c80-8b7f-e0325f69d7cf',
  },
  {
    Hostname: 'sessionsbythebay',
    Name: 'Sessions by the Bay',
    ID: '2c6ddb8c-b311-4181-8a6a-da4cba49ff34',
  },
  {
    Hostname: 'sevenstars',
    Name: '7 Stars - Richmond',
    ID: '99786264-bc51-4ac2-9a7f-3ab89771781f',
  },
  {
    Hostname: 'sfdv',
    Name: 'Sol Flower - Deer Valley',
    ID: 'ead90958-5d2a-4c7c-851a-42c8ef92a9ca',
  },
  {
    Hostname: 'sfe',
    Name: 'Sol Flower - Tempe',
    ID: 'b4e46145-984b-44ea-a588-efefa7ef5719',
  },
  {
    Hostname: 'sfs',
    Name: 'Sol Flower - Scottsdale',
    ID: 'ff75fed4-a283-45af-a5fe-61ebb1e4fe18',
  },
  {
    Hostname: 'sft2',
    Name: 'Sol Flower - Tempe University',
    ID: 'e04ec232-2044-468b-b79d-05bb5c4a1ecd',
  },
  {
    Hostname: 'sfw',
    Name: 'Sol Flower - Sun City',
    ID: 'b7b7fe14-edd2-4adc-ab3d-54e2c40de842',
  },
  {
    Hostname: 'silverleaf',
    Name: 'Silverleaf Wellness',
    ID: '8ec5f701-377f-4fce-8b2f-c837d4841eaa',
  },
  {
    Hostname: 'sj1',
    Name: 'Caliva - San Jose #1',
    ID: '67fc5ede-a5ef-479f-a9f0-a75c19766686',
  },
  {
    Hostname: 'sj2',
    Name: 'Caliva - San Jose Deli',
    ID: '99184a4d-abd3-4321-b100-3ddd4bdbc3a9',
  },
  {
    Hostname: 'sjc-airfield',
    Name: 'Airfield - San Jose Retail',
    ID: 'b4021349-12a1-4731-b88b-fa5371d26aee',
  },
  {
    Hostname: 'skunkmasters',
    Name: 'Skunkmasters',
    ID: '15f1c8e9-1e77-4dae-9a40-9a9fbb1c7409',
  },
  {
    Hostname: 'slocalroots',
    Name: 'SLOCAL Roots - SLO',
    ID: '13edb8aa-a701-4caf-9e36-e2e641fce8c6',
  },
  {
    Hostname: 'slocalrootsgb',
    Name: 'SLOCAL Roots - Grover Beach',
    ID: 'be948f38-5ce2-4218-be0b-09c6578b40fe',
  },
  {
    Hostname: 'slocalrootsguad',
    Name: 'Slocal - Guadalupe',
    ID: 'a62dc95c-ccd3-476d-ab11-1a3e61caee00',
  },
  {
    Hostname: 'smartweed',
    Name: 'Smart Weed - LA',
    ID: '92e1cf1d-1f49-4477-ab09-dcaf5a647753',
  },
  {
    Hostname: 'soar-grenada',
    Name: 'SOAR - Grenada',
    ID: '92319a93-1384-404b-9789-359d22b3767e',
  },
  {
    Hostname: 'soar-olivebranch',
    Name: 'SOAR - Olive Branch',
    ID: '566594fb-6a9e-4058-9e5c-059c0038f0d1',
  },
  {
    Hostname: 'soar-oxford',
    Name: 'SOAR - Oxford',
    ID: '750b559d-6c3e-4a29-940c-9aeae5eafddc',
  },
  {
    Hostname: 'soar-starkville',
    Name: 'SOAR - Starkville',
    ID: '48cd61e8-2fd7-488a-bd24-6f40b5a9d5ec',
  },
  {
    Hostname: 'solacemedsfc',
    Name: 'Solace Meds- Smokey',
    ID: '9ca1a232-4611-4326-a1a3-cb912db67a97',
  },
  {
    Hostname: 'solacemedsmas',
    Name: 'Solace Meds- Mason',
    ID: '3fb3a62d-8441-4d5f-8943-cb4a7e8bead7',
  },
  {
    Hostname: 'solacemedswr',
    Name: 'Solace Meds - Wheat Ridge',
    ID: '8afead5d-40af-4402-9e1f-b8d6c124a658',
  },
  {
    Hostname: 'solful',
    Name: 'Solful - Sebastopol',
    ID: '4363c068-435f-46d7-8154-2e0ae3234b8a',
  },
  {
    Hostname: 'solful-healdsburg',
    Name: 'Solful - Healdsburg',
    ID: 'dafd9e02-c127-42f3-a79d-4bd67927db8c',
  },
  {
    Hostname: 'solful-irving',
    Name: 'Solful - Irving',
    ID: 'b2b0afb0-bf18-4475-a8bd-94b99270df41',
  },
  {
    Hostname: 'som-latham',
    Name: 'State of Mind Dispensary - Latham',
    ID: 'a0c499d6-39d2-4bee-a6e9-63cb3b79384b',
  },
  {
    Hostname: 'somersetgreen',
    Name: 'Somerset Green',
    ID: '64c29575-80c3-413f-94d3-b0e22cf94a64',
  },
  {
    Hostname: 'sparchaight',
    Name: 'SPARC - Haight',
    ID: 'ec300d0f-2c2d-4aa2-ba00-9da8eaf043c4',
  },
  {
    Hostname: 'sparchof',
    Name: 'Sparc - Hall of Flowers',
    ID: '2417d97b-02f0-476e-aa21-12284c184a2f',
  },
  {
    Hostname: 'sparclove',
    Name: 'SPARC - Loveshack',
    ID: '4669fd37-2ebc-4a3a-aae1-134493a1b5f9',
  },
  {
    Hostname: 'sparcnapa',
    Name: 'SPARC - Napa',
    ID: '36f9fc2c-5267-484f-8551-617e257430c1',
  },
  {
    Hostname: 'sparcpolk',
    Name: 'SPARC - Polk',
    ID: 'b0cd62cd-27ae-4d72-89d4-2869b53a307c',
  },
  {
    Hostname: 'sparcsantarosa',
    Name: 'SPARC - Santa Rosa',
    ID: 'fcb5a9b9-b333-4efb-8650-eec333dcee80',
  },
  {
    Hostname: 'sparcsebastopol',
    Name: 'SPARC - Sebastopol',
    ID: '4d4301ae-0170-4c33-adfc-c9316833e4c9',
  },
  {
    Hostname: 'sparcsonoma',
    Name: 'SPARC - Sonoma',
    ID: 'bb3264c8-60a2-4391-8336-cf6497f197f1',
  },
  {
    Hostname: 'st1',
    Name: 'Coastal - Stockton',
    ID: '2c9c60ad-94f4-4190-9f55-07745efbcaed',
  },
  {
    Hostname: 'standard-test-env',
    Name: 'standard-test-env',
    ID: '853bfd64-5b3e-4ed7-9c1a-1e164e21a7c9',
  },
  {
    Hostname: 'stashdash',
    Name: 'Stash Dash - Atwater',
    ID: 'c529f896-c1c4-4c10-aa85-618dcb245d0e',
  },
  {
    Hostname: 'stashoh',
    Name: 'Stash - Orland Hills',
    ID: 'e757fb7f-1559-4e85-bf65-0095a2c13e12',
  },
  {
    Hostname: 'stashperu',
    Name: 'Stash - Peru',
    ID: '17e5174c-4238-43a6-9f9c-fa0a1bfaa609',
  },
  {
    Hostname: 'stickythumb',
    Name: 'Sticky Thumb - South SF',
    ID: '80fbd892-d6de-4318-af32-6effb522d31d',
  },
  {
    Hostname: 'stickythumb510',
    Name: 'Sticky Thumb - Hayward',
    ID: '4db1628b-6a22-4b3c-9731-6b433ff021af',
  },
  {
    Hostname: 'stilolbc',
    Name: 'Stilo Dispensary',
    ID: '603b8718-04b3-4694-a495-6b1345a0c5b1',
  },
  {
    Hostname: 'strains',
    Name: 'Strains - Perris',
    ID: 'b4c922b7-e3d4-4db8-874d-6207d9fc93c1',
  },
  {
    Hostname: 'strainsforlifeny',
    Name: 'Strains for Life NY',
    ID: 'e2f390cd-7d1d-4d29-84df-37f61919c76c',
  },
  {
    Hostname: 'streetkingsla',
    Name: 'Street Kings - DTLA',
    ID: 'b1f674ed-5bfe-4fd6-832a-6fed46a12e8f',
  },
  {
    Hostname: 'sublime',
    Name: 'Sublime Cannabis - Mashpee',
    ID: 'a20f19d0-9d05-4b36-be07-043042d51fbe',
  },
  {
    Hostname: 'sundial',
    Name: 'Sundialed Collective - Redding',
    ID: '4c7c59f8-8c3b-4f96-8e76-62e52c4b59c4',
  },
  {
    Hostname: 'sundial2',
    Name: 'NUG X Sundial - Redding',
    ID: '3a726377-03dd-4eff-84e4-9e2caf2ced89',
  },
  {
    Hostname: 'sundial3',
    Name: 'Sundialed Collective - Red Bluff',
    ID: '6c6bbbee-c5ea-48ad-8288-44bd265ac2d4',
  },
  {
    Hostname: 'sundial4',
    Name: 'Sundialed Collective - Bishop',
    ID: 'baf6c6de-956b-44f3-8679-5475db8f7389',
  },
  {
    Hostname: 'sundial5',
    Name: 'Sundialed - Banning',
    ID: 'bc80983d-b3fc-43b1-b1fd-75a3a1d232ee',
  },
  {
    Hostname: 'sundial6',
    Name: 'Sundialed Collective - Red Bluff Express',
    ID: '679a145f-2381-4fe3-a4ab-d2799adb8f1c',
  },
  {
    Hostname: 'sundialsandiego',
    Name: '',
    ID: '',
  },
  {
    Hostname: 'sundialwoodland',
    Name: 'Sundialed Collective - Woodland',
    ID: '5b6791ee-1176-4636-bb72-705b4b1dd138',
  },
  {
    Hostname: 'sunset',
    Name: 'Sunset Retail',
    ID: '4b89ce2e-17a4-40bc-ada1-23ff0901046b',
  },
  {
    Hostname: 'sunsetpipeline',
    Name: 'Sunset Pipeline - SF',
    ID: '3382ee77-043d-462d-bf2c-34dced02e669',
  },
  {
    Hostname: 'sunsetsocial',
    Name: 'Sunset Social Club',
    ID: 'e8a23505-c31e-4e50-b320-2df011cd6091',
  },
  {
    Hostname: 'superior',
    Name: 'The Superior Dispensary - Phoenix',
    ID: '7e4d152e-a23b-4760-a214-3f9961fdfb16',
  },
  {
    Hostname: 'supportsandbox1',
    Name: '',
    ID: '',
  },
  {
    Hostname: 'sussex',
    Name: 'Sussex Pharms',
    ID: 'c2dca103-5388-49e6-b4f5-6e3c6ce147c0',
  },
  {
    Hostname: 'swadecherokee',
    Name: 'Swade - Cherokee',
    ID: '0cceda42-7c4b-477b-ac0d-6c6dbbfb9b82',
  },
  {
    Hostname: 'swadedelmar',
    Name: 'Swade - Delmar',
    ID: '93e0ed43-f74d-47e6-891a-3f98afb28dc4',
  },
  {
    Hostname: 'swadeeureka',
    Name: 'Swade - Eureka',
    ID: '9e306a43-bc52-4a6d-9b34-4e6782135cf1',
  },
  {
    Hostname: 'swadegrove',
    Name: 'Swade - The Grove',
    ID: '15b4fbdb-ff50-460b-a5cc-b4efe99fdfa3',
  },
  {
    Hostname: 'swaderolla',
    Name: 'Swade - Rolla',
    ID: 'd8a19ee3-8643-4054-a184-6867f55a4bf2',
  },
  {
    Hostname: 'swadestp',
    Name: 'Swade - St. Peters',
    ID: '8c80034f-0b8e-44eb-8a31-10d1fa7a4548',
  },
  {
    Hostname: 'swishcannabis',
    Name: 'Swish - North Hollywood',
    ID: '30626990-0929-4191-97c1-219c0d069217',
  },
  {
    Hostname: 'symbioticsacramento',
    Name: 'Symbiotic Sacramento',
    ID: 'd7d8fb59-bfa0-45ad-b026-14ebe07dde77',
  },
  {
    Hostname: 'syndicatedeserthotsprings',
    Name: 'The Syndicate - Desert Hot Springs',
    ID: '50f629d2-0e9f-4f7c-b484-3a2a12c89599',
  },
  {
    Hostname: 'syndicatehuntingtonpark',
    Name: 'The Syndicate - Huntington Park',
    ID: 'bf00b0f4-146f-423a-a63f-76864da97d4a',
  },
  {
    Hostname: 'syndicatelakeelsinore1',
    Name: 'The Syndicate - Lake Elsinore #1',
    ID: '17504834-d9f1-4308-86b4-53e9a698498b',
  },
  {
    Hostname: 'syndicatelakeelsinore2',
    Name: 'The Syndicate - Lake Elsinore #2',
    ID: '2006b03a-269c-4631-a813-d25bc95ae759',
  },
  {
    Hostname: 'syndicatelongbeach',
    Name: 'The Syndicate - Long Beach',
    ID: '7e10bd7e-3362-4c8a-982b-89f32f6fbbe4',
  },
  {
    Hostname: 'syndicatemorenovalley',
    Name: 'The Syndicate - Moreno Valley',
    ID: 'c1b7956d-1067-4695-9001-cac1783fb58a',
  },
  {
    Hostname: 'syndicatenorthridge',
    Name: 'The Syndicate - Northridge',
    ID: 'ced9cfc7-31d2-46c2-9bff-d8b36fe8e658',
  },
  {
    Hostname: 'syndicateriverside',
    Name: 'The Syndicate - Riverside',
    ID: '9a9a958c-1618-40c3-bdef-6043db606923',
  },
  {
    Hostname: 'syndicatetarzana',
    Name: 'The Syndicate - Tarzana',
    ID: 'e1ba606e-508d-4d46-bf8f-c263eab05f38',
  },
  {
    Hostname: 'syndicatewoodlandhills',
    Name: 'The Syndicate - Woodland Hills',
    ID: '8ad7100a-15b7-40dd-b041-c7704b525ce3',
  },
  {
    Hostname: 'tahoegreen',
    Name: 'Tahoe Green',
    ID: 'beb4f8dc-017e-4248-a19a-382294a3670e',
  },
  {
    Hostname: 'tahoewellness',
    Name: 'Tahoe Wellness',
    ID: '2dcfe45a-f3f2-4c3f-999e-d8999856c75a',
  },
  {
    Hostname: 'tcs-hoboken',
    Name: 'Terrapin Care Station - Hoboken',
    ID: 'c37539b1-69a6-4b3b-85d0-0114d11ae0af',
  },
  {
    Hostname: 'tgp',
    Name: 'The Green Paradise - LA',
    ID: '8dc9ac6a-e317-49cf-9735-011bccd99d54',
  },
  {
    Hostname: 'thcbro',
    Name: 'The Herbal Center- Broadway',
    ID: 'bd1620d2-fea0-4539-9b94-4b8881347eb5',
  },
  {
    Hostname: 'thcpeo',
    Name: 'The Herbal Center- Peoria',
    ID: '7aef55cf-17a2-48d1-9331-ee67d258cf75',
  },
  {
    Hostname: 'theagriculturalist',
    Name: 'The Agriculturalist',
    ID: '29973d30-086a-4a74-b0db-4aab3dd7cd7a',
  },
  {
    Hostname: 'thebrightspot',
    Name: 'The Bright Spot - Fairfield',
    ID: '1e27b7e5-82a8-47c3-8f9a-bbc938147b0e',
  },
  {
    Hostname: 'thecakehouse-battlecreekmi',
    Name: 'Cake House - Battlecreek',
    ID: '997fa0bc-9c8e-4891-9ebb-cd4ee648aab7',
  },
  {
    Hostname: 'thecakehouse-coronaca',
    Name: 'The Cake House - Corona',
    ID: 'af57fa7b-83bc-4ced-a1f4-3ea67e7303bc',
  },
  {
    Hostname: 'thecakehouse-detroit',
    Name: 'The Cake House- Detroit',
    ID: '9e3f1241-5c86-4008-a4e7-7c2f411f9233',
  },
  {
    Hostname: 'thecakehouse-elmonte',
    Name: 'The Cake House- El Monte',
    ID: '9d64f8c7-922d-4b26-a58c-22a03b9a4d45',
  },
  {
    Hostname: 'thecakehouse-sandiego',
    Name: 'The Cake House San Diego (Golden State Greens - San Diego)',
    ID: 'bebfbd35-23e0-4a19-90c6-1bfb4fa2ec3f',
  },
  {
    Hostname: 'thecakehouse-sanjose',
    Name: 'The Cake House San Jose',
    ID: '5bf25327-02f6-4525-a41d-f2f147ca948f',
  },
  {
    Hostname: 'thecakehouse-santafevistaca',
    Name: 'The Cake House - Vista',
    ID: '21b2b85a-7fa8-4975-9047-fa770477569a',
  },
  {
    Hostname: 'thecakehouse-wildomarca',
    Name: 'The Cake House - Wildomar',
    ID: 'c7557b81-24a8-4f49-a289-43b81a40fe2d',
  },
  {
    Hostname: 'thecenter',
    Name: 'The Center',
    ID: '73837091-0569-4b4a-948e-02cae07b675d',
  },
  {
    Hostname: 'thecirclelbc',
    Name: 'The Circle - Long Beach',
    ID: '2860ced4-a626-4051-894c-16c87e005965',
  },
  {
    Hostname: 'thecornerlbc',
    Name: 'The Corner - Long Beach',
    ID: '36ec253d-d181-406d-94e4-d257ef43c44c',
  },
  {
    Hostname: 'thedropla',
    Name: 'The Drop - LA',
    ID: '9f3fcaf8-12c4-4143-ada2-8a9b5c5a1219',
  },
  {
    Hostname: 'thefarmacyiv',
    Name: 'IV - Farmacy',
    ID: '7681861f-a272-448c-a88e-3ec6a6527132',
  },
  {
    Hostname: 'thefarmacysb',
    Name: 'SB - Farmacy',
    ID: '83f25dcc-82df-433d-bfda-a6c595c508ef',
  },
  {
    Hostname: 'thefrostednug',
    Name: 'The Frosted Nug',
    ID: 'c1636624-bde1-477b-b4f6-e3e13b6c84c6',
  },
  {
    Hostname: 'thehealingcenterma',
    Name: 'The Healing Center - Fitchburg',
    ID: '4ff4faa2-5323-4cb1-ab81-938c26fa6abb',
  },
  {
    Hostname: 'thehealingtree',
    Name: 'The Healing Tree - Lake Elsinore',
    ID: '5731f22a-27ee-4487-bc44-c351eab692ca',
  },
  {
    Hostname: 'thehigherpath',
    Name: 'The Higher Path - Sherman Oaks',
    ID: '901dd179-0657-4869-8b99-77ff3946cc00',
  },
  {
    Hostname: 'thehighlands',
    Name: 'Highlands Dispensary - Livermore',
    ID: 'd60e6026-973f-4738-91e4-cda996d653d7',
  },
  {
    Hostname: 'thehill',
    Name: 'The Hill',
    ID: '20ad64f3-1189-46c8-9d2c-2660d5fba0ce',
  },
  {
    Hostname: 'themedicinewoman',
    Name: 'The Medicine Woman - Bellflower',
    ID: '4694b684-a63a-4af1-ad8d-8366d8fe64fc',
  },
  {
    Hostname: 'themedicinewomannj',
    Name: 'The Medicine Woman- Jersey City',
    ID: '6cced1c4-feea-442f-b4f1-8d41e0e63673',
  },
  {
    Hostname: 'theo',
    Name: 'THEO - Franklin Park',
    ID: '01890261-33a8-4e9e-ba0c-112b5f1e50f3',
  },
  {
    Hostname: 'thepottery',
    Name: 'Pottery',
    ID: 'db41a64b-e193-44e0-8397-72c92d34b927',
  },
  {
    Hostname: 'theraleaf',
    Name: 'Theraleaf - San Jose',
    ID: 'd60efbac-0489-4c64-bdf1-14be60a39fbc',
  },
  {
    Hostname: 'thereserve',
    Name: 'The Reserve - La Mesa',
    ID: '201f7557-a0e6-45a3-aa65-70da180fd77f',
  },
  {
    Hostname: 'thesanctuary',
    Name: 'The Sanctuary - Sac',
    ID: '923e80b7-d207-4d4d-8b32-6737f071a616',
  },
  {
    Hostname: 'thesanctuarygarden',
    Name: 'The Sanctuary Garden',
    ID: 'fa24923e-6f1f-4936-948a-5a2e0733d608',
  },
  {
    Hostname: 'thesecretgardenle',
    Name: 'The Secret Garden - Lake Elsinore',
    ID: '36559593-ff8f-4bfa-bb6b-b8fff7f35cbe',
  },
  {
    Hostname: 'thewoods',
    Name: 'ERBA WeHo - The Woods',
    ID: '8907fc1d-df08-4c7b-b878-eccc332f5bbe',
  },
  {
    Hostname: 'thewoodsdet',
    Name: 'The Woods - Detroit',
    ID: '7d582e9f-cd8d-49f9-847a-1884668d0956',
  },
  {
    Hostname: 'thewoodsmarcellus',
    Name: 'The Woods - Marcellus',
    ID: '2360a26b-0472-4efe-be5f-16a07b9bb195',
  },
  {
    Hostname: 'thewoodsmtpleasant',
    Name: 'The Woods - Mount Pleasant',
    ID: 'b7db3cd5-0720-49d8-a278-0101760a397a',
  },
  {
    Hostname: 'thewoodswestbranch',
    Name: 'The Woods - West Branch',
    ID: 'c9c32b60-fdb5-4f53-a7f5-e38e5776ba75',
  },
  {
    Hostname: 'thewoodswhitehall',
    Name: 'The Woods - Whitehall',
    ID: 'b7858a3b-577e-428c-bbfe-114d2df3240f',
  },
  {
    Hostname: 'threefoot',
    Name: 'Three Foot',
    ID: 'a2257ae0-d8ef-441b-94dc-f836d88b6d84',
  },
  {
    Hostname: 'threesisterscollective',
    Name: 'Three Sisters Collective',
    ID: 'bacc22fd-331c-471e-9fde-9c8564e2f526',
  },
  {
    Hostname: 'tiogagreen',
    Name: 'Tioga Green - Lee Vining',
    ID: '1fbe1d32-bcdd-4eb7-a47f-f9328469e4c4',
  },
  {
    Hostname: 'torreydistro',
    Name: 'Torrey - Distro',
    ID: '12e53784-1410-48e6-8112-db4f890ea065',
  },
  {
    Hostname: 'torreyholistics',
    Name: 'Torrey Holistics - San Diego',
    ID: 'fd8f6d29-fd76-454f-90b8-397f3a9c1d75',
  },
  {
    Hostname: 'tosd',
    Name: 'The Other Side Dispensary - Jersey City',
    ID: 'd1d03e1e-572a-4f9a-8e6c-0915a0edad7d',
  },
  {
    Hostname: 'tracycannabisco',
    Name: 'Tracy Cannabis Collective',
    ID: 'bd370b95-3a55-47b8-b800-395426ff8196',
  },
  {
    Hostname: 'traditionalbh',
    Name: 'Traditional - Boyle Heights',
    ID: 'b159c896-d521-4e72-ae82-c17297865b35',
  },
  {
    Hostname: 'traditionaldtla',
    Name: 'Traditional - DTLA',
    ID: '7082a266-1655-4691-a298-87348c2e0cc2',
  },
  {
    Hostname: 'traditionallax',
    Name: 'Traditional - LAX',
    ID: '7593ede5-0895-4a4e-9f93-874ba7991d80',
  },
  {
    Hostname: 'traditionalpico',
    Name: 'Traditional - Pico',
    ID: '51b35325-5723-4fa2-b9e4-903542de16e5',
  },
  {
    Hostname: 'trendslic',
    Name: 'Trends',
    ID: '9e3ab7ce-878d-494c-9746-5c9a66972515',
  },
  {
    Hostname: 'triplec',
    Name: 'Triple C Collective',
    ID: 'd666d65a-2954-4a13-8626-0742c50be251',
  },
  {
    Hostname: 'trubliss',
    Name: 'TruBliss - Mesa',
    ID: 'f2b01ca1-37fd-4c4a-80b1-57ca65073b7c',
  },
  {
    Hostname: 'truessence',
    Name: 'Tru Essence',
    ID: 'ed52260d-2d6a-470d-b46e-20862447734a',
  },
  {
    Hostname: 'turlocknhc',
    Name: 'Turlock - NHC',
    ID: '0b475ea5-f47d-4f97-a8c7-b39423efe7ad',
  },
  {
    Hostname: 'ubuntu24-creation-test',
    Name: '',
    ID: '',
  },
  {
    Hostname: 'uforia',
    Name: 'Uforia - Jersey City',
    ID: '01dae405-3076-4a63-b927-720cb829b499',
  },
  {
    Hostname: 'unionstation',
    Name: 'Union Station - SF',
    ID: '1908d404-a46b-48ef-b7da-c9192e8075ef',
  },
  {
    Hostname: 'uproot',
    Name: 'Uproot - Worcester',
    ID: '8374241a-477c-410e-94bb-56b8c9a6985e',
  },
  {
    Hostname: 'uptownfunk',
    Name: 'Uptown Funk - Jackson',
    ID: '95310185-2519-43de-ace8-2ad91d219869',
  },
  {
    Hostname: 'urbansmokela',
    Name: 'Urban Smoke - LA',
    ID: '05857048-806d-481f-b826-440010384d1c',
  },
  {
    Hostname: 'urber',
    Name: 'Urber',
    ID: '993385dd-be57-46ca-a9f8-902ad8422809',
  },
  {
    Hostname: 'va1',
    Name: 'Coastal - Vallejo',
    ID: '4a0b4e74-8cde-4168-96b4-433c17d19af0',
  },
  {
    Hostname: 'valleypurefarmersville',
    Name: 'Valley Pure - Farmersville',
    ID: 'af793af6-2447-49ef-b43c-80d14bb69a34',
  },
  {
    Hostname: 'valleypurelemoore',
    Name: 'Valley Pure - Lemoore',
    ID: 'c1ff4575-270e-462a-b910-03872b019be8',
  },
  {
    Hostname: 'valleypurelindsay',
    Name: 'Valley Pure - Lindsay',
    ID: '3e371058-84d3-4e3d-93c2-820c7c78e25d',
  },
  {
    Hostname: 'valleypuretulare',
    Name: 'Valley Pure - Tulare',
    ID: '745a73ee-7bbd-4df9-8257-97bc21c2829a',
  },
  {
    Hostname: 'valleypurewoodlake',
    Name: 'Valley Pure - Woodlake',
    ID: '2d2af509-7e40-44c6-844a-cd68dd1c4873',
  },
  {
    Hostname: 'velvet',
    Name: 'Velvet - Martinez',
    ID: 'dbd3cf1c-12eb-4fe9-bdbf-eae78a8b1486',
  },
  {
    Hostname: 'velvetbrentwood',
    Name: 'Velvet - Brentwood',
    ID: '558f76c4-dec6-4822-a96c-0ed2d27a8198',
  },
  {
    Hostname: 'velveteaglerock',
    Name: 'Velvet - Eagle Rock',
    ID: 'fe14b663-a5f7-4096-ba57-4e4bf77e15fe',
  },
  {
    Hostname: 'velvetnapa',
    Name: 'Velvet - Napa',
    ID: '588701c7-c353-4507-997e-9cd99a8832d3',
  },
  {
    Hostname: 'ventura',
    Name: 'Wheelhouse - Ventura',
    ID: '8a368996-7fb8-4272-a79f-7ce5173a78f4',
  },
  {
    Hostname: 'vertical-cairo',
    Name: 'Vertical - Cairo',
    ID: '31034a5b-a221-42ff-b007-3bf9402730b2',
  },
  {
    Hostname: 'vertical-cary',
    Name: 'Vertical - Cary',
    ID: 'eff364bc-4d71-4c7f-a9cd-dfdccaea1bbe',
  },
  {
    Hostname: 'vertsfortcollins',
    Name: 'Verts - Fort Collins',
    ID: '9ff225fe-1d42-4a84-aed1-7f1cc16895ce',
  },
  {
    Hostname: 'vertsgl',
    Name: 'Verts - Grand Lake',
    ID: 'ace531c3-a9d3-4fc9-9256-6e746c605ac6',
  },
  {
    Hostname: 'vertsgolden',
    Name: 'Verts - Golden',
    ID: 'a0208055-6e32-461a-b0ed-757d5ed53e1c',
  },
  {
    Hostname: 'vertstc',
    Name: 'Verts - Traverse City',
    ID: 'b96f8b82-d105-4cb4-8ddc-36593bff1c47',
  },
  {
    Hostname: 'violabro',
    Name: 'Viola - Broadview',
    ID: 'a047acb3-83a2-4339-b3c1-154a3fb4d59b',
  },
  {
    Hostname: 'violaolive',
    Name: 'Viola Olive',
    ID: 'b520f99b-874d-46ca-9611-fe9190653108',
  },
  {
    Hostname: 'vrc',
    Name: 'Vallejo Relief Center',
    ID: '839bf07a-582d-4d8b-8206-f07fe0ba2272',
  },
  {
    Hostname: 'wearehemp',
    Name: 'We Are Hemp - Hayward',
    ID: '1b58a4e7-0e5b-4ed7-a853-c3875e482f70',
  },
  {
    Hostname: 'weho',
    Name: 'Alternative Herbal Health Services',
    ID: 'fd1b1c42-a516-49a3-950b-2e4405f73dc7',
  },
  {
    Hostname: 'westcliffwellness',
    Name: '3 Bros - Santa Cruz',
    ID: '4eed7b55-b9f7-4435-b765-c4be950dec31',
  },
  {
    Hostname: 'wheelhouse',
    Name: 'Wheelhouse - Port Hueneme',
    ID: '0ed22114-4d20-4068-a0e6-e7e9eb406ea8',
  },
  {
    Hostname: 'wildseedmv',
    Name: 'Perfect Union - Wild Seed Wellness',
    ID: '9bee142b-f48c-42a2-8680-207c22d099d5',
  },
  {
    Hostname: 'wonderbrett-labrea',
    Name: 'WONDERBRETT - La Brea',
    ID: 'd4360793-6e73-4670-87ce-66ba0c4c5f28',
  },
  {
    Hostname: 'wonderland',
    Name: 'Wonderland Cannabis Co. - Millbury',
    ID: '7da56ea4-22e4-42fa-b605-b66e164a893d',
  },
  {
    Hostname: 'woodlandcannabis',
    Name: 'Woodland Cannabis',
    ID: '4b6cb8fa-6c23-40d2-b640-f9cf2ca0fb51',
  },
  {
    Hostname: 'woolwich',
    Name: 'Woolwich Wellness Company- Carneys Point',
    ID: 'd170f5ac-3dac-4fb3-99c1-1e46b5a5a5e3',
  },
  {
    Hostname: 'xena',
    Name: 'Xena',
    ID: 'c334a42e-c8d7-4174-9973-cd118e634482',
  },
  {
    Hostname: 'xwcc',
    Name: 'Xzibit’s West Coast Cannabis',
    ID: '97bcd411-37a7-4558-a037-cbfd72fe05a5',
  },
  {
    Hostname: 'yumadispensary',
    Name: 'Jamestown - Yuma',
    ID: 'cc9608b8-ade7-4b0f-83c4-1543d1037771',
  },
  {
    Hostname: 'zacate',
    Name: 'Zacate - Delran',
    ID: '537c04cf-988c-4977-8305-7042e2261549',
  },
  {
    Hostname: 'zen209',
    Name: 'Zen Garden Wellness - Stockton',
    ID: 'e01beb86-ec51-4098-877f-4b9256e8587d',
  },
  {
    Hostname: 'zen916',
    Name: 'Zen Garden Wellness - Sacramento Northgate',
    ID: '72dfa05d-eded-40e1-8499-eef6f40393b9',
  },
  {
    Hostname: 'zensouthsac',
    Name: 'Zen Garden South Sac',
    ID: '0cd3113f-44ab-4c2b-bccb-574383c8a7d4',
  },
]

// Record keyed by entity ID with the corresponding entity as value
export const EntitiesById: Record<string, (typeof Entities)[number]> = Entities.reduce(
  (acc, entity) => {
    if (entity.ID) acc[entity.ID] = entity
    return acc
  },
  {} as Record<string, (typeof Entities)[number]>,
)
